import React from 'react';
import '../../../App.css';
import "../../../Shineout.css";
import withStyles from "@material-ui/core/styles/withStyles";
import MaterialTable from 'material-table';
import { withCookies } from "react-cookie";
import { routePermissions } from "../../auth/network/Login";
import { csvbundleUploader, preview } from "../network/CsvbundleUploader";
import { getPO } from "../network/TVActivator";
import { getSummaryCount } from "../network/Authwalls";
import { get as getResources } from "../network/Resources";
import { get as getFeatures } from "../network/Features";
import { get as getBoards } from "../network/Uiconfigs";
import { Form, Card, Message, Upload, Grid, Input, Select, Rule, Alert } from 'shineout';
import { boardLabel, boardName } from '../util/board';
import { 
    CircularProgress, 
    LinearProgress, 
    Dialog, 
    DialogTitle, 
    DialogContent, 
    DialogActions, 
    Typography,
    Tooltip,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper
} from '@material-ui/core';
import { 
    CheckCircleOutline, 
    ErrorOutline, 
    InfoOutlined, 
    CloudUpload, 
    Storage, 
    GetApp,
    Refresh,
    Download,
    Cached,
    Visibility,
    ArrowLeft
} from '@material-ui/icons';

const service = 'csvbundle_uploader';
const path = '';
const UPLOAD_URL = '/lm/v1/uploader/c';
const rules = Rule();
const MAX_MAC_RANGE = 20000;

// Define styles object
const styles = theme => ({
    // ... (keep all your existing styles)
    theme: theme,
    root: {
        display: 'wrap',
    },
    container: {
        display: 'block',
        flexWrap: 'wrap',
    },
    fab: {
        margin: theme.spacing(1),
    },
    box: {
        component: 'div',
        display: 'inline',
        flexWrap: 'wrap',
    },
    card: {
        padding: theme.spacing(3),
        margin: theme.spacing(2),
        borderRadius: '12px',
        boxShadow: '0 4px 20px rgba(0,0,0,0.08)',
    },
    textField: {
        margin: 8,
        padding: theme.spacing(1),
        width: 200,
    },
    media: {
        paddingTop: '56.25%',
    },
    hidediv: {
        position: 'absolute !important',
        top: '-9999px !important',
        left: '-9999px !important',
        visibility: 'hidden !important',
    },
    toggleContainer: {
        display: 'flex',
        justifyContent: 'center',
        marginBottom: '20px',
        borderBottom: '1px solid #e0e0e0',
        paddingBottom: '10px',
    },
    toggleButton: {
        padding: '12px 40px',
        margin: '0 10px',
        border: '2px solid #1976d2',
        backgroundColor: 'transparent',
        color: '#1976d2',
        cursor: 'pointer',
        borderRadius: '8px',
        fontSize: '14px',
        fontWeight: 600,
        transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
        display: 'flex',
        alignItems: 'center',
        gap: '8px',
        '&:hover': {
            backgroundColor: '#e3f2fd',
            transform: 'translateY(-2px)',
            boxShadow: '0 4px 12px rgba(25, 118, 210, 0.2)',
        },
    },
    toggleButtonActive: {
        backgroundColor: '#1976d2',
        color: 'white',
        boxShadow: '0 4px 12px rgba(25, 118, 210, 0.3)',
        '&:hover': {
            backgroundColor: '#1565c0',
        }
    },
    statsContainer: {
        display: 'flex',
        gap: '16px',
        margin: '20px 0',
        flexWrap: 'wrap',
    },
    statCard: {
        padding: '16px',
        borderRadius: '8px',
        backgroundColor: '#f8f9fa',
        border: '1px solid #e0e0e0',
        minWidth: '140px',
        textAlign: 'center',
        flex: 1,
    },
    statValue: {
        fontSize: '24px',
        fontWeight: 'bold',
        margin: '8px 0',
    },
    statLabel: {
        fontSize: '12px',
        color: '#666',
        textTransform: 'uppercase',
        letterSpacing: '0.5px',
    },
    statPositive: {
        color: '#2e7d32',
    },
    statNegative: {
        color: '#d32f2f',
    },
    statNeutral: {
        color: '#1976d2',
    },
    previewSection: {
        marginBottom: '24px',
        padding: '16px',
        backgroundColor: '#f8f9fa',
        borderRadius: '8px',
        border: '1px solid #e0e0e0',
    },
    statsGrid: {
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fill, minmax(200px, 1fr))',
        gap: '16px',
        marginBottom: '16px',
    },
    statItem: {
        padding: '12px',
        backgroundColor: 'white',
        borderRadius: '6px',
        border: '1px solid #e0e0e0',
        textAlign: 'center',
    },
    previewButton: {
        backgroundColor: '#ff9800',
        '&:hover': {
            backgroundColor: '#f57c00',
        },
    },
    previewCard: {
        padding: '20px',
        backgroundColor: '#f0f7ff',
        border: '2px solid #1976d2',
        borderRadius: '10px',
        margin: '20px 0',
    },
    modernButton: {
        padding: '12px 24px',
        backgroundColor: '#1976d2',
        color: 'white',
        border: 'none',
        borderRadius: '8px',
        cursor: 'pointer',
        fontSize: '14px',
        fontWeight: 600,
        textTransform: 'uppercase',
        letterSpacing: '0.5px',
        transition: 'all 0.3s',
        display: 'flex',
        alignItems: 'center',
        gap: '8px',
        '&:hover': {
            backgroundColor: '#1565c0',
            transform: 'translateY(-2px)',
            boxShadow: '0 6px 20px rgba(25, 118, 210, 0.3)',
        },
        '&:disabled': {
            backgroundColor: '#b0bec5',
            cursor: 'not-allowed',
            transform: 'none',
            boxShadow: 'none',
        },
    },
    secondaryButton: {
        backgroundColor: '#6c757d',
        '&:hover': {
            backgroundColor: '#5a6268',
        },
    },
    successButton: {
        backgroundColor: '#2e7d32',
        '&:hover': {
            backgroundColor: '#1b5e20',
        },
    },
    warningButton: {
        backgroundColor: '#ff9800',
        '&:hover': {
            backgroundColor: '#f57c00',
        },
    },
    uploadArea: {
        border: '2px dashed #1976d2',
        borderRadius: '12px',
        padding: '40px 20px',
        textAlign: 'center',
        backgroundColor: '#f8f9fa',
        cursor: 'pointer',
        transition: 'all 0.3s',
        '&:hover': {
            backgroundColor: '#e3f2fd',
            borderColor: '#1565c0',
        },
    },
    uploadErrorArea: {
        border: '2px dashed #d32f2f',
        borderRadius: '12px',
        padding: '40px 20px',
        textAlign: 'center',
        backgroundColor: '#ffebee',
        cursor: 'pointer',
        transition: 'all 0.3s',
    },
    loadingOverlay: {
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(255, 255, 255, 0.9)',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        zIndex: 9999,
        flexDirection: 'column',
        gap: '20px',
    },
    loadingText: {
        marginTop: '20px',
        color: '#1976d2',
        fontSize: '18px',
        fontWeight: 500,
    },
    formSection: {
        marginBottom: '24px',
        padding: '20px',
        backgroundColor: 'white',
        borderRadius: '8px',
        border: '1px solid #e0e0e0',
    },
    formSectionTitle: {
        fontSize: '16px',
        fontWeight: 600,
        color: '#1976d2',
        marginBottom: '16px',
        display: 'flex',
        alignItems: 'center',
        gap: '8px',
    },
    macInputGroup: {
        display: 'grid',
        gridTemplateColumns: '1fr 1fr',
        gap: '16px',
        marginBottom: '16px',
    },
    headerActions: {
        display: 'flex',
        justifyContent: 'flex-end',
        alignItems: 'center',
        gap: '12px',
        marginBottom: '20px',
    },
    actionButton: {
        display: 'flex',
        alignItems: 'center',
        gap: '8px',
        padding: '8px 16px',
        backgroundColor: '#1976d2',
        color: 'white',
        border: 'none',
        borderRadius: '6px',
        cursor: 'pointer',
        fontSize: '14px',
        fontWeight: 500,
        transition: 'all 0.3s',
        '&:hover': {
            backgroundColor: '#1565c0',
            transform: 'translateY(-1px)',
        },
    },
    resetButton: {
        backgroundColor: '#6c757d',
        '&:hover': {
            backgroundColor: '#5a6268',
        },
    },
    downloadButton: {
        backgroundColor: '#2e7d32',
        '&:hover': {
            backgroundColor: '#1b5e20',
        },
    },
    successResultContainer: {
        padding: '20px',
        backgroundColor: '#f1f8e9',
        borderRadius: '8px',
        border: '1px solid #c5e1a5',
        margin: '16px 0',
    },
    downloadPrompt: {
        backgroundColor: '#e3f2fd',
        padding: '20px',
        borderRadius: '8px',
        border: '2px dashed #1976d2',
        textAlign: 'center',
        margin: '20px 0',
    },
    actionButtonsContainer: {
        display: 'flex',
        gap: '12px',
        justifyContent: 'center',
        marginTop: '16px',
    },
    statusBadge: {
        padding: '2px 8px',
        borderRadius: '4px',
        fontSize: '12px',
        fontWeight: 500,
    },
    statusWillUpload: {
        backgroundColor: '#e8f5e8',
        color: '#2e7d32',
    },
    statusDuplicate: {
        backgroundColor: '#fff3e0',
        color: '#f57c00',
    },
    statusExists: {
        backgroundColor: '#ffebee',
        color: '#d32f2f',
    },
    statusInvalid: {
        backgroundColor: '#f5f5f5',
        color: '#757575',
    },
    previewTable: {
        marginTop: '16px',
        maxHeight: '200px',
        overflowY: 'auto',
    },
    buttonGroup: {
        display: 'flex',
        gap: '12px',
        justifyContent: 'center',
        marginTop: '20px',
        padding: '20px',
        borderTop: '1px solid #e0e0e0',
    },
    errorTableContainer: {
        marginTop: '20px',
        maxHeight: '400px',
        overflow: 'auto',
    },
    errorTableCell: {
        padding: '8px',
        fontSize: '12px',
    },
    errorRow: {
        backgroundColor: '#fff3f0',
        '&:hover': {
            backgroundColor: '#ffe6e0',
        }
    },
    uploadErrorText: {
        color: '#d32f2f',
        fontSize: '12px',
        marginTop: '8px',
        textAlign: 'center'
    }
});

class BundleUploader extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            columns: [
                { title: 'EMAC', field: 'emac' },
                { title: 'SERIAL NO', field: 'serialno' },
                { title: 'ERROR MESSAGE', field: 'error_message' },
            ],
            data: [],
            policy: JSON.parse(this.props?.cookies?.cookies?.policy),
            xlsx_data: [],
            table: '',
            isLoading: true,
            POST: false,
            GET: false,
            PUT: false,
            DELETE: false,
            POST_DATA: [],
            GET_DATA: [],
            PUT_DATA: [],
            DELETE_DATA: [],
            mboards: [],
            brands: [],
            vendors: [],
            creatable_fields: [],
            editable_fields: [],
            fields: [],
            visible_fields: [],
            isAllVisible: false,
            isAllEditable: false,
            
            // Upload mode
            uploadMode: 'csv',
            
            // Common form state
            brand: '',
            mboard: '',
            vendor: '',
            factory: '',
            model: '',
            features: [],
            factorys: [],
            boards: [],
            featuresList: [],
            
            // CSV specific state
            fileUploading: false,
            fileAnalysis: null,
            duplicateCount: 0,
            uniqueCount: 0,
            invalidCount: 0,
            showConfirmUpload: false,
            fileErrors: [],
            uploadedFileData: null,
            uploadedFileName: null,
            uploadErrorMessage: null,
            activePanel: null, // 'csv' | 'macrange' | null

            // MAC Range specific state
            start_mac: '',
            end_mac: '',
            batch_name: '',
            batch_description: '',
            previewCount: 0,
            previewStart: '',
            previewEnd: '',
            isPreviewingRange: false,
            macValidation: { isValid: false, message: '' },
            
            // Upload process state
            isUploading: false,
            uploadProgress: 0,
            uploadProcessed: 0,
            uploadTotal: 0,
            uploadStatus: null,
            uploadResult: null,
            showResultDialog: false,
            
            // Form validation
            formErrors: {},
            isFormValid: false,
            touched: {},
            
            // Export state
            isExporting: false,
            lastSessionId: null,
            lastBatchId: null,
            
            // Form reset counter
            formResetKey: 0,
            uploadKey: 0,
            
            // Success state with download option
            showDownloadOption: false,
            downloadSessionInfo: null,
            
            // Preview state
            isAnalyzingPreview: false,
            previewData: null,
            showPreviewDialog: false,
            previewSummary: null,
            previewDuplicateMacs: [],

            // MAC range local preview
            macPreviewData: null,
            isGeneratingMacPreview: false,

            // Validation errFdownlors from preview/upload
            validationErrors: null,
            showValidationDialog: false,

            // Duplicate + unique split (errorCode 108)
            duplicateRows: [],
            uniqueRows: [],
            showDuplicateDialog: false,
            allDuplicates: false, // true when every MAC in CSV is a duplicate — persists after dialog close

            // PO license balance from TVActivator
            poData: null,
            poLoading: false,

            // System-level quota from getSummaryCount
            summaryCount: null,
        };
    }

    componentWillMount() {
        const cookiePolicy = JSON.parse(this.props.cookies.cookies.policy || '[]');
        const policyname = this.props.cookies.cookies.policyname || '';

        const isVendor = policyname !== 'admin';
        const hasService = cookiePolicy.includes('csvbundle_uploader');

        if (isVendor || hasService) {
            this.setState({ POST: true, GET: true, PUT: true });
            this.loadInitialData();
        }

        // Always fetch the policy's resources (e.g. the mboard allow-list) so the boards
        // dropdown can be scoped to what this account is actually assigned, even for
        // vendor accounts that were already fast-tracked into the page above.
        routePermissions(this.props, { service: service, path: path }, result => {
            if (result === null) {
                if (!isVendor && !hasService) {
                    Message.error('No permission to access this route', 3, { position: 'bottom-right' });
                }
                return;
            }
            result.map(method => {
                this.setState({ [method.name]: true });
                this.setState({ [method.name + '_DATA']: method.resources });
            });
            if (!isVendor && !hasService) {
                this.loadInitialData();
            }
        });
    }


    showValidationErrors = (errors, errorMessage) => {
    console.log("Showing validation errors:", errors);
    
    // Format the errors for display
    const formattedErrors = errors.map((err, idx) => ({
        emac: err.emac || 'N/A',
        serialno: err.serialno || '',
        description: err.description || '',
        error_message: err.error_message || err.error || err.reason || 'Validation failed',
        row: err.row || idx + 1
    }));
    
    this.setState({
        validationErrors: formattedErrors,
        showValidationDialog: true,
        uploadErrorMessage: `${errorMessage} (${formattedErrors.length} issue(s))`
    });
    
    Message.error(`${errorMessage}. ${formattedErrors.length} issue(s) found. Click to see details.`, 6, { position: 'bottom-right' });
};


    loadInitialData = () => {
        getResources({ type: 'brand' }, (data) => {
            var brands = [];
            data.map(brand_element => brands.push(brand_element.name));
            this.setState({ brands: brands });
        });

        getResources({ type: 'vendor' }, (data) => {
            var vendors = [];
            const policyname = this.props.cookies.cookies.policyname;
            if (policyname === 'cvte_admin' || policyname === 'cvte_lite') {
                vendors.push("CVTE");
            }
            else if (policyname === 'videoscape_policy') {
                vendors.push("VIDEOSCAPE");
            } else {
                data.map(vendor_element => vendors.push(vendor_element.name));
            }
            this.setState({ vendors: vendors });
        });

        getResources({ type: 'factory' }, (data) => {
            var factorys = [];
            data.map(factory_element => factorys.push(factory_element.name));
            this.setState({ factorys: factorys });
        });

        getSummaryCount(count => {
            if (count && count.count) {
                this.setState({ summaryCount: count.count });
            }
        });

        this.setState({ isLoading: false }, () => this.validateForm());
    }

    fetchPOData = (vendor) => {
        if (!vendor) {
            this.setState({ poData: null });
            return;
        }
        this.setState({ poLoading: true });
        getPO(vendor, (data) => {
            this.setState({ poData: data, poLoading: false });
        });
    }

    computeAttributes = (brand, features) => {
        const attrs = new Set();

        // Brand sets the base — _LX and LITE replace REGULAR_OS
        if (brand && brand.includes('_LX')) {
            attrs.add('LINUX_OS');
        } else if (brand && brand.includes('LITE')) {
            attrs.add('LITE_OS');
        } else {
            attrs.add('REGULAR_OS');
            if (brand && brand.includes('ALEXA')) attrs.add('ALEXA');
        }

        // Features append additional attributes
        (features || []).forEach(f => {
            if (f === 'AVS')           attrs.add('ALEXA');
            if (f === 'CLOUDTV_VOICE') attrs.add('CLOUDTV_VOICE');
        });

        return Array.from(attrs);
    }

    handleBrandChange = (value) => {
        const autoAttributes = this.computeAttributes(value, this.state.features);
        this.setState({ brand: value, attributes: autoAttributes }, () => {
            this.markTouched('brand');
            this.validateForm();
        });

        if (value) {
            getFeatures({ brands: [value] }, (data) => {
                var features = [];
                data.map(e => features.push(e.name));
                this.setState({ featuresList: features });
            });

            getBoards({ brand: [value] }, (data) => {
                var boards = [];
                var listboards = [];
                data.map(e => boards.push(e.board + '@' + e.keymd5));

                if (boards.length > 0) {
                    for (var j = 0; j < boards.length; j++) {
                        var str = boards[j];
                        var myarray = str.split(',');

                        if (myarray.length <= 1) {
                            var last = myarray[0];
                            var keymd5get = last.split('@');
                            listboards.push(boardLabel(keymd5get[0], keymd5get[1]))
                        } else {
                            var last = myarray.slice(-1)[0];
                            var keymd5get = last.split('@');
                            var newarray = myarray.pop();
                            myarray.push(keymd5get[0]);
                            myarray = myarray.map(c => boardLabel(c, keymd5get[1]));
                            listboards.push.apply(listboards, myarray);
                        }
                    }
                }

                let uniqueChars = [];
                listboards.forEach((c) => {
                    if (!uniqueChars.includes(c)) {
                        uniqueChars.push(c);
                    }
                });

                // Scope boards to this account's assigned mboard list (if not '*')
                const mboardResource = (this.state.POST_DATA || []).find(e => e.key === 'mboard');
                if (mboardResource && mboardResource.value.indexOf('*') === -1) {
                    const allowedMboards = mboardResource.value;
                    uniqueChars = uniqueChars.filter(c => {
                        const rawBoard = boardName(c);
                        return allowedMboards.indexOf(rawBoard) > -1;
                    });
                }

                uniqueChars.sort();
                this.setState({ boards: uniqueChars });
            });
        }

    }

    markTouched = (field) => {
        this.setState(prev => ({ touched: { ...prev.touched, [field]: true } }));
    }

    markAllTouched = (callback) => {
        this.setState({
            touched: {
                brand: true, mboard: true, model: true, vendor: true, factory: true,
                file: true, start_mac: true, end_mac: true,
            }
        }, () => {
            this.validateForm();
            if (callback) callback();
        });
    }

    _checkPOLimit = (count) => {
        const { poData, attributes } = this.state;
        if (!poData || !poData.po || !attributes || attributes.length === 0) return null;
        const osAttrs = ['REGULAR_OS', 'LITE_OS', 'LINUX_OS'];
        const primaryAttr = attributes.find(a => osAttrs.includes(a));
        if (!primaryAttr) return null;
        const poEntry = poData.po.find(p => p.attribute === primaryAttr);
        if (!poEntry) return null;
        if (poEntry.remaining <= 0) {
            return `No remaining ${primaryAttr} licenses. Balance: ${poEntry.remaining.toLocaleString()}`;
        }
        if (count > poEntry.remaining) {
            return `Count (${count.toLocaleString()}) exceeds remaining ${primaryAttr} licenses (${poEntry.remaining.toLocaleString()})`;
        }
        return null;
    }

    _checkSummaryQuota = (emacCount) => {
        const { summaryCount, attributes } = this.state;
        if (!summaryCount || !attributes || attributes.length === 0) return null;

        let hasIssue = false;
        const issueLines = [];
        const allQuotaLines = [];

        attributes.forEach(attr => {
            const entry = summaryCount.find(x => x.attribute === attr);
            if (!entry) return;

            allQuotaLines.push(`• ${attr}: ${entry.remaining}`);

            if (entry.remaining <= 0) {
                hasIssue = true;
                issueLines.push(attr);
            } else if (emacCount > entry.remaining) {
                hasIssue = true;
                issueLines.push(attr);
            }
        });

        if (!hasIssue) return null;

        return `Cannot generate EMACs. Insufficient quota for: ${issueLines.join(', ')}.\n\nRemaining quota:\n${allQuotaLines.join('\n')}\n\nPlease contact CloudTV support.`;
    }

 validateForm = () => {
    const { uploadMode, brand, mboard, vendor, factory, model, features, start_mac, end_mac, xlsx_data, uploadedFileData } = this.state;

    let errors = {};
    let isValid = true;

    if (!brand)   { errors.brand   = 'Please select a Brand';   isValid = false; }
    if (!mboard)  { errors.mboard  = 'Please select a Board';   isValid = false; }
    if (!model)   { errors.model   = 'Please select a Model';   isValid = false; }
    if (!vendor)  { errors.vendor  = 'Please select a Vendor';  isValid = false; }
    if (!factory) { errors.factory = 'Please select a Factory'; isValid = false; }

    if (uploadMode === 'csv') {
        // Check both xlsx_data and uploadedFileData for file data
        const hasFileData = (xlsx_data && xlsx_data.length > 0) || (uploadedFileData && uploadedFileData.length > 0);
        if (!hasFileData) {
            errors.file = 'CSV/Excel file is required';
            isValid = false;
        }
    } else {
        if (!start_mac) { errors.start_mac = 'Please enter a Start MAC address'; isValid = false; }
        if (!end_mac) { errors.end_mac = 'Please enter an End MAC address'; isValid = false; }

        const macRegex = /^([0-9A-Fa-f]{2}[:-]?){5}([0-9A-Fa-f]{2})$/;
        if (start_mac && !macRegex.test(start_mac)) {
            errors.start_mac = 'Invalid MAC — use only hex digits (0-9, A-F), e.g. 8C:7A:B3:DE:A9:40';
            isValid = false;
        }

        if (end_mac && !macRegex.test(end_mac)) {
            errors.end_mac = 'Invalid MAC — use only hex digits (0-9, A-F), e.g. 8C:7A:B3:DE:A9:40';
            isValid = false;
        }

        if (start_mac && end_mac && !errors.start_mac && !errors.end_mac) {
            const cleanStart = start_mac.replace(/[:\-]/g, '').toUpperCase();
            const cleanEnd = end_mac.replace(/[:\-]/g, '').toUpperCase();
            const startInt = parseInt(cleanStart, 16);
            const endInt = parseInt(cleanEnd, 16);

            if (!isNaN(startInt) && !isNaN(endInt) && startInt > endInt) {
                errors.range = 'Start MAC must be less than or equal to End MAC';
                isValid = false;
            } else if (!isNaN(startInt) && !isNaN(endInt)) {
                const count = endInt - startInt + 1;
                if (count > MAX_MAC_RANGE) {
                    errors.range = `Range too large (${count.toLocaleString()} addresses). Maximum allowed is ${MAX_MAC_RANGE.toLocaleString()}`;
                    isValid = false;
                }
            }
        }
    }

    this.setState({ formErrors: errors, isFormValid: isValid });
    console.log("validateForm result - isValid:", isValid, "errors:", errors);
    return isValid;
}

    validateMacAddress = (mac) => {
        if (!mac) return { isValid: false, message: 'MAC address is required' };

        const macRegex = /^([0-9A-Fa-f]{2}[:-]?){5}([0-9A-Fa-f]{2})$/;
        if (!macRegex.test(mac)) {
            return { isValid: false, message: 'Invalid MAC format. Use 12 hex chars (with or without : or -)' };
        }

        const cleanMac = mac.replace(/[:\-]/g, '').toUpperCase();
        if (cleanMac.length !== 12) {
            return { isValid: false, message: 'MAC must be exactly 12 hex characters' };
        }

        return { isValid: true, message: 'Valid MAC address' };
    }

    handleMacChange = (field, value) => {
        this.setState({ [field]: value, uploadMode: 'macrange', macPreviewData: null }, () => {
            this.markTouched(field);
            this.validateForm();
        });
    }

    validateMacRange = () => {
        const { start_mac, end_mac } = this.state;

        if (!start_mac || !end_mac) {
            return { isValid: false, message: 'Please enter both start and end MAC addresses' };
        }

        const cleanStart = start_mac.replace(/[:\-]/g, '').toUpperCase();
        const cleanEnd = end_mac.replace(/[:\-]/g, '').toUpperCase();

        const macRegex = /^[0-9A-F]{12}$/;
        if (!macRegex.test(cleanStart)) {
            return { isValid: false, message: 'Invalid Start MAC format' };
        }
        if (!macRegex.test(cleanEnd)) {
            return { isValid: false, message: 'Invalid End MAC format' };
        }

        const startInt = parseInt(cleanStart, 16);
        const endInt = parseInt(cleanEnd, 16);

        if (isNaN(startInt) || isNaN(endInt)) {
            return { isValid: false, message: 'Invalid MAC address values' };
        }

        if (startInt > endInt) {
            return { isValid: false, message: 'Start MAC must be less than or equal to End MAC' };
        }

        const count = endInt - startInt + 1;

        if (count > MAX_MAC_RANGE) {
            return {
                isValid: false,
                message: `MAC range too large (${count.toLocaleString()} addresses). Maximum allowed is ${MAX_MAC_RANGE.toLocaleString()} addresses.`
            };
        }

        return {
            isValid: true,
            message: `Valid range with ${count.toLocaleString()} addresses`,
            count: count,
            startInt: startInt,
            endInt: endInt
        };
    }

    generateMacPreview = () => {
        const { start_mac, end_mac, brand, mboard, model, vendor, factory, batch_name, batch_description, features } = this.state;
        const validation = this.validateMacRange();
        if (!validation.isValid) {
            Message.error(validation.message, 3, { position: 'bottom-right' });
            return;
        }
        this.setState({ isGeneratingMacPreview: true });
        setTimeout(() => {
            const cleanStart = start_mac.replace(/[:\-]/g, '').toUpperCase();
            const cleanEnd = end_mac.replace(/[:\-]/g, '').toUpperCase();
            const startInt = parseInt(cleanStart, 16);
            const endInt = parseInt(cleanEnd, 16);
            const rows = [];
            for (let i = startInt; i <= endInt; i++) {
                const hex = i.toString(16).toUpperCase().padStart(12, '0');
                const emac = hex.match(/.{2}/g).join(':');
                rows.push({ emac, brand, board: boardName(mboard), model: model || '', features: (features || []).join(', '), vendor, factory, batch_name: batch_name || '', description: batch_description || batch_name || '' });
            }
            this.setState({ macPreviewData: rows, isGeneratingMacPreview: false });
        }, 0);
    }

    downloadMacPreviewCSV = () => {
        const { macPreviewData, batch_name, batch_description } = this.state;
        if (!macPreviewData || macPreviewData.length === 0) return;

        const esc = v => (v || '').replace(/"/g, '""');
        const formDesc = esc(batch_description || batch_name || '');

        const lines = ['EMAC,SERIALNO,DESCRIPTION'];
        macPreviewData.forEach((r, i) => {
            lines.push(`"${esc(r.emac)}","${i + 1}","${formDesc}"`);
        });

        const blob = new Blob([lines.join('\n') + '\n'], { type: 'text/csv;charset=utf-8;' });
        const url  = URL.createObjectURL(blob);
        const a    = document.createElement('a');
        a.href     = url;
        a.download = `mac_preview_${batch_name || 'mac_range'}.csv`;
        a.click();
        URL.revokeObjectURL(url);
    }

    handleFileUpload = (res, file, data, afterCallback) => {
    console.log("=== HANDLE FILE UPLOAD ===");
    console.log("Response type:", typeof res);
    console.log("Response:", res);
    console.log("File name:", file?.name);
    
    // Clear previous error
    this.setState({ uploadErrorMessage: null });
    
    try {
        let parsedRes = res;
        
        // Parse if it's a string
        if (typeof res === 'string') {
            try {
                parsedRes = JSON.parse(res);
                console.log("Parsed response:", parsedRes);
            } catch (e) {
                console.log("Response is not JSON");
                parsedRes = res;
            }
        }
        
        // Handle error response from backend (errorCode 101-108)
        if (parsedRes && parsedRes.errorCode) {
            console.log("Backend returned error code:", parsedRes.errorCode);

            // errorCode 108: some MACs already exist — show duplicates + unique lists
            console.log('108 check:', String(parsedRes.errorCode) === '108', 'hasDuplicates:', parsedRes.hasDuplicates, 'data count:', (parsedRes.data||[]).length);
            if (String(parsedRes.errorCode) === '108' && parsedRes.hasDuplicates) {
                const allDataRows = (parsedRes.data || []).map((err, idx) => ({
                    emac: err.emac || 'N/A',
                    serialno: err.serialno || '',
                    description: err.description || '',
                    error_message: err.error || 'Already exists in database',
                    row: err.row || idx + 1
                }));
                const uniqueRows = parsedRes.valid_rows || [];
                const uniqueMacSet = new Set(uniqueRows.map(r => r.emac));
                const duplicateRows = uniqueMacSet.size > 0
                    ? allDataRows.filter(r => !uniqueMacSet.has(r.emac))
                    : allDataRows;
                this.setState({
                    uploadedFileData: uniqueRows.length > 0 ? uniqueRows : duplicateRows,
                    xlsx_data: uniqueRows.length > 0 ? uniqueRows : duplicateRows,
                    uploadedFileName: this.state.uploadedFileName || 'uploaded_file',
                    fileErrors: duplicateRows,
                    fileAnalysis: null,
                    uploadErrorMessage: null,
                    validationErrors: null,
                    showValidationDialog: false,
                    duplicateRows,
                    uniqueRows,
                    showDuplicateDialog: true,
                    allDuplicates: uniqueRows.length === 0 && duplicateRows.length > 0,
                }, () => { this.validateForm(); });
                Message.warning(
                    `${duplicateRows.length} duplicate MAC(s) found. ${uniqueRows.length} unique MAC(s) can be uploaded.`,
                    6, { position: 'bottom-right' }
                );
                return;
            }

            const errorMsg = parsedRes.errorMessage || 'File validation failed';
            const errorData = parsedRes.data || [];

            // Format error data for display
            const formattedErrors = errorData.map((err, idx) => ({
                emac: err.emac || err.mac || 'N/A',
                serialno: err.serialno || '',
                description: err.description || '',
                error_message: err.error || err.reason || parsedRes.errorMessage,
                row: err.row || idx + 1
            }));

            // Store errors and show warning
            this.setState({
                uploadedFileData: null,
                xlsx_data: [],
                fileErrors: formattedErrors,
                fileAnalysis: null,
                table: '',
                uploadErrorMessage: `${errorMsg}. ${formattedErrors.length} issue(s) found.`,
                validationErrors: formattedErrors,
                showValidationDialog: true
            }, () => {
                this.validateForm();
            });

            Message.warning(`${errorMsg}. ${formattedErrors.length} issue(s) found.`, 6, { position: 'bottom-right' });
            return;
        }
        
        // Handle case where response is an array directly (success case)
        let uploadedData = [];
        if (Array.isArray(parsedRes)) {
            uploadedData = parsedRes;
        } 
        else if (parsedRes && parsedRes.data && Array.isArray(parsedRes.data)) {
            uploadedData = parsedRes.data;
        } 
        else if (parsedRes && typeof parsedRes === 'object' && parsedRes.emac) {
            uploadedData = [parsedRes];
        }
        
        // Normalise: pick only emac/serialno/description, strip separators, uppercase, validate hex
        const MAC_REGEX = /^[0-9A-F]{12}$/;
        const validRows = [];
        const invalidRows = [];

        uploadedData.forEach((row, idx) => {
            const normalised = {};
            Object.keys(row).forEach(key => {
                const lk = key.toLowerCase().trim();
                if (lk === 'emac')               normalised.emac        = row[key];
                else if (lk === 'serialno')      normalised.serialno    = row[key];
                else if (lk === 'description')   normalised.description = row[key];
            });

            // Clean and validate the emac value
            const rawEmac = String(normalised.emac || '').trim();
            const cleanEmac = rawEmac.replace(/[:\-]/g, '').toUpperCase();

            if (!rawEmac) {
                invalidRows.push({
                    row: idx + 1,
                    emac: '(empty)',
                    serialno: normalised.serialno || '',
                    error_message: 'EMAC is missing',
                });
            } else if (!MAC_REGEX.test(cleanEmac)) {
                invalidRows.push({
                    row: idx + 1,
                    emac: rawEmac,
                    serialno: normalised.serialno || '',
                    error_message: `"${rawEmac}" is not a valid EMAC. Only hex characters (0-9 and A-F) are allowed. Expected format: 8C:7A:B3:DE:A9:40 or 8C7AB3DEA940`,
                });
            } else {
                validRows.push({ ...normalised, emac: cleanEmac });
            }
        });

        console.log("Valid rows:", validRows.length, "Invalid rows:", invalidRows.length);

        if (invalidRows.length > 0) {
            this.setState({
                uploadedFileData: null,
                xlsx_data: [],
                fileErrors: invalidRows,
                fileAnalysis: null,
                table: '',
                uploadErrorMessage: `${invalidRows.length} row(s) have invalid EMAC values. Fix them and re-upload.`,
                validationErrors: invalidRows,
                showValidationDialog: true,
            }, () => { this.validateForm(); });
            Message.warning(`${invalidRows.length} invalid EMAC row(s) found. Please fix and re-upload.`, 6, { position: 'bottom-right' });
            return;
        }

        uploadedData = validRows;

        if (!uploadedData || uploadedData.length === 0) {
            const errorMsg = "No valid data found in file. Please check the file format.";
            this.setState({
                uploadErrorMessage: errorMsg,
                uploadedFileData: null,
                xlsx_data: []
            }, () => {
                this.validateForm();
            });
            Message.error(errorMsg, 5, { position: 'bottom-right' });
            return;
        }
        
        // Clear any previous errors and set the data
        this.setState(prev => ({
            uploadedFileData: uploadedData,
            xlsx_data: uploadedData,
            uploadedFileName: file?.name || null,
            uploadMode: 'csv',
            fileErrors: [],
            validationErrors: null,
            showValidationDialog: false,
            uploadErrorMessage: null,
            touched: { ...prev.touched, file: true },
        }), () => {
            this.validateForm();
            Message.success(`Successfully loaded ${uploadedData.length} valid entries from file`, 3, { position: 'bottom-right' });
            if (typeof afterCallback === 'function') afterCallback();
        });
        
    } catch (error) {
        console.error("Error in handleFileUpload:", error);
        const errorMsg = "Failed to process file: " + (error.message || "Unknown error");
        this.setState({
            uploadedFileData: null,
            xlsx_data: [],
            fileErrors: [],
            uploadErrorMessage: errorMsg,
            validationErrors: null
        }, () => {
            this.validateForm();
        });
        Message.error(errorMsg, 5, { position: 'bottom-right' });
    }
};

validateFileOnDemand = () => {
    const { uploadedFileData } = this.state;

    if (!uploadedFileData || uploadedFileData.length === 0) {
        return { isValid: true, errors: [] };
    }

    const errors = [];
    const seenMacs = new Set(); // Track duplicates within the file

    uploadedFileData.forEach((item, index) => {
        const itemErrors = [];

        if (!item.emac) {
            itemErrors.push('EMAC is required');
        } else {
            const mac = item.emac.toString().toUpperCase();
            const cleanMac = mac.replace(/[:\-]/g, '');
            if (cleanMac.length !== 12 || !/^[0-9A-F]{12}$/.test(cleanMac)) {
                itemErrors.push('Invalid MAC format');
            } else {
                if (seenMacs.has(cleanMac)) {
                    itemErrors.push('Duplicate MAC address in file');
                } else {
                    seenMacs.add(cleanMac);
                }
            }
        }


        if (itemErrors.length > 0) {
            errors.push({
                emac: item.emac || '(empty)',
                serialno: item.serialno || '',
                error_message: itemErrors.join(', '),
                row_index: index + 1
            });
        }
    });

    return { isValid: errors.length === 0, errors };
}

    handlePreviewUpload = () => {
        // markAllTouched commits touched state first, then validates inside callback
        // so all empty-field errors appear in the UI before we bail out
        this.markAllTouched(() => {
            this._doPreviewUpload();
        });
    }

    _doPreviewUpload = () => {
        const { uploadMode, start_mac, end_mac, brand, mboard, vendor, factory, features, model, batch_name, batch_description, uploadedFileData, xlsx_data } = this.state;

        if (!this.validateForm()) {
            const { formErrors } = this.state;
            const missing = Object.values(formErrors).filter(Boolean);
            Message.error(missing.length ? `Please fix: ${missing.join(' • ')}` : 'Please fill all required fields before preview', 5, { position: 'bottom-right' });
            return;
        }

        if (uploadMode === 'macrange') {
            const rangeValidation = this.validateMacRange();

            if (!rangeValidation.isValid) {
                this.setState({
                    validationErrors: [{
                        emac: `${start_mac} → ${end_mac}`,
                        serialno: '',
                        description: '',
                        error_message: rangeValidation.message
                    }],
                    showValidationDialog: true
                });
                return;
            }

            if (!start_mac || !end_mac) {
                Message.error('Please enter both start and end MAC addresses', 3, { position: 'bottom-right' });
                return;
            }
        }

        if (uploadMode === 'csv') {
            const validation = this.validateFileOnDemand();

            if (!validation.isValid) {
                this.setState({
                    validationErrors: validation.errors,
                    showValidationDialog: true
                });
                return;
            }

            if (!uploadedFileData || uploadedFileData.length === 0) {
                Message.error('Please upload a CSV file first', 3, { position: 'bottom-right' });
                return;
            }
        }

        let previewData = {};

        if (uploadMode === 'macrange') {
            const cleanStart = start_mac.replace(/[:\-]/g, '').toUpperCase();
            const cleanEnd = end_mac.replace(/[:\-]/g, '').toUpperCase();

            previewData = {
                start_mac: cleanStart,
                end_mac: cleanEnd,
                brand: brand,
                mboard: mboard,
                vendor: vendor,
                factory: factory,
                model: model,
                features: features,
                batch_name: batch_name,
                batch_description: batch_description,
                description: batch_description || ''
            };
        } else {
            const rawData = uploadedFileData || xlsx_data;
            const fileData = rawData.map(row => ({
                ...row,
                description: row.description || batch_description || '',
            }));
            previewData = {
                emacs: fileData,
                brand: brand,
                mboard: mboard,
                vendor: vendor,
                factory: factory,
                model: model,
                features: features,
                batch_description: batch_description
            };
        }

        this.setState({ isAnalyzingPreview: true });

        fetch('/lm/v1/csvbundle_uploader/preview', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${this.props.cookies.cookies.token}`
            },
            body: JSON.stringify(previewData)
        })
            .then(response => response.json())
            .then(data => {
                if (data.status === "success") {
                    if (uploadMode === 'macrange') {
                        const rangeValidation = this.validateMacRange();
                        this.setState({
                            previewCount: rangeValidation.count || 0,
                            previewStart: start_mac,
                            previewEnd: end_mac
                        });
                    }

                    this.setState({
                        previewData: data.preview,
                        showPreviewDialog: true,
                        previewSummary: this.generatePreviewSummary(data.preview, uploadMode),
                        previewDuplicateMacs: data.preview.duplicate_macs || [],
                    });

                    Message.success('Preview generated successfully', 3, { position: 'bottom-right' });
                } else {
                    Message.error(data.message || 'Preview failed', 3, { position: 'bottom-right' });
                }
            })
            .catch(error => {
                console.error('Preview error:', error);
                Message.error('Failed to generate preview', 3, { position: 'bottom-right' });
            })
            .finally(() => {
                this.setState({ isAnalyzingPreview: false });
            });
    }

    generatePreviewSummary = (previewData, uploadMode) => {
        if (uploadMode === 'macrange') {
            return {
                title: 'MAC Range Preview',
                items: [
                    { label: 'Total MACs in range', value: previewData.total_count, color: '#1976d2' },
                    { label: 'Unique (will be uploaded)', value: previewData.unique_count, color: '#2e7d32' },
                    { label: 'Duplicates (will be skipped)', value: previewData.duplicate_count, color: '#f57c00' },
                    { label: 'Start MAC', value: previewData.start_mac, color: '#1976d2' },
                    { label: 'End MAC', value: previewData.end_mac, color: '#1976d2' }
                ],
                message: previewData.message
            };
        } else {
            return {
                title: 'CSV File Preview',
                items: [
                    { label: 'Total entries in file', value: previewData.file_statistics.total_entries, color: '#1976d2' },
                    { label: 'Valid MAC addresses', value: previewData.file_statistics.valid_entries, color: '#1976d2' },
                    { label: 'Invalid entries', value: previewData.file_statistics.invalid_entries, color: '#d32f2f' },
                    { label: 'Unique in file', value: previewData.file_statistics.unique_in_file, color: '#1976d2' },
                    { label: 'Duplicates in file', value: previewData.file_statistics.duplicates_in_file, color: '#f57c00' },
                    { label: 'Already in system', value: previewData.database_check.existing_in_system, color: '#f57c00' },
                    { label: 'Will be uploaded', value: previewData.database_check.will_be_uploaded, color: '#2e7d32' }
                ],
                message: previewData.summary.message
            };
        }
    }

    handleSubmit = (formData) => {
        if (!this.validateForm()) {
            Message.error('Please fix all validation errors before proceeding', 3, { position: 'bottom-right' });
            return;
        }

        this.handlePreviewUpload();
    }

    confirmUpload = () => {
        this.setState({ showPreviewDialog: false });

        setTimeout(() => {
            this.processUpload();
        }, 500);
    }

    processUpload = () => {
        this.markAllTouched(() => {
            this._doProcessUpload();
        });
    }

    _doProcessUpload = () => {
        const { uploadMode, start_mac, end_mac, brand, mboard, vendor, factory, batch_name, batch_description, model, features, uploadedFileData, xlsx_data } = this.state;

        if (!this.validateForm()) {
            const { formErrors } = this.state;
            const missing = Object.values(formErrors).filter(Boolean);
            Message.error(missing.length ? `Please fix: ${missing.join(' • ')}` : 'Please fill all required fields before uploading', 5, { position: 'bottom-right' });
            return;
        }

        if (uploadMode === 'csv') {
            const validation = this.validateFileOnDemand();

            if (!validation.isValid) {
                this.setState({
                    validationErrors: validation.errors,
                    showValidationDialog: true
                });
                return;
            }
        }

        let request_data;

        let resolvedEmacs;

        if (uploadMode === 'macrange') {
            const cleanStart = start_mac.replace(/[:\-]/g, '').toUpperCase();
            const cleanEnd = end_mac.replace(/[:\-]/g, '').toUpperCase();
            const startInt = parseInt(cleanStart, 16);
            const endInt = parseInt(cleanEnd, 16);
            const rangeEmacs = [];
            for (let i = startInt; i <= endInt; i++) {
                const hex = i.toString(16).toUpperCase().padStart(12, '0');
                rangeEmacs.push({ emac: hex, description: batch_description || '' });
            }
            resolvedEmacs = rangeEmacs;
            request_data = {
                emacs: rangeEmacs,
                brand: brand,
                mboard: mboard,
                model: model || '',
                features: features || [],
                attributes: this.computeAttributes(brand, features || []),
                factory: factory,
                vendor: vendor,
                batch_name: batch_name || '',
                batch_description: batch_description || '',
                description: batch_description || '',
                state: '1'
            };
        } else {
            const rawData = uploadedFileData || xlsx_data;
            resolvedEmacs = rawData.map(row => ({
                ...row,
                // CSV description wins; fall back to form description
                description: row.description || batch_description || '',
            }));
            request_data = {
                emacs: resolvedEmacs,
                brand: brand,
                mboard: mboard,
                model: model || '',
                features: features || [],
                attributes: this.computeAttributes(brand, features || []),
                factory: factory,
                vendor: vendor,
                batch_name: batch_name || '',
                batch_description: batch_description || '',
                state: '1'
            };
        }

        const emacCount = resolvedEmacs.length;
        const attributes = this.state.attributes || ['REGULAR_OS'];
        const osAttrs = ['REGULAR_OS', 'LITE_OS', 'LINUX_OS'];
        const primaryAttr = attributes.find(a => osAttrs.includes(a)) || 'REGULAR_OS';

        const doUpload = () => {
            this.setState({
                isUploading: true,
                uploadProgress: 0,
                uploadProcessed: 0,
                uploadTotal: 0,
                showConfirmUpload: false,
                uploadedFileData: resolvedEmacs,
                xlsx_data: resolvedEmacs,
            });

            const token = this.props.cookies.cookies.token;
            csvbundleUploader(request_data, (status, data) => {

            if (status === true) {
                const successMessage = uploadMode === 'macrange'
                    ? `Successfully generated ${data.generated_count || this.state.previewCount} MAC addresses!`
                    : 'EMACs activated successfully!';
                // Show 100% briefly before closing the overlay
                this.setState({ uploadProgress: 100 }, () => {
                    setTimeout(() => {
                        this.setState({
                            isUploading: false,
                            uploadProgress: 0,
                            uploadStatus: 'success',
                            uploadResult: data,
                            showResultDialog: false,
                            lastSessionId: data.session_id,
                            lastBatchId: data.batch_id,
                            showDownloadOption: data.inserted_count > 0,
                            downloadSessionInfo: {
                                session_id: data.session_id,
                                batch_id: data.batch_id,
                                count: data.inserted_count,
                                type: uploadMode,
                                batch_name: batch_name
                            }
                        });
                    }, 600);
                });

            } else {
                let errorMessage = 'Failed to upload MAC addresses';
                if (data && data.message) {
                    errorMessage = data.message;
                } else if (data && data.status === 406) {
                    errorMessage = 'Insufficient license balance';
                } else if (data && data.status === 409) {
                    errorMessage = 'Some MAC addresses already exist';
                }
                Message.error(errorMessage, 5, { position: 'bottom-right' });
                this.setState({ isUploading: false, uploadProgress: 0, uploadProcessed: 0, uploadTotal: 0, uploadStatus: 'error', uploadResult: data, showResultDialog: true, showDownloadOption: false });
            }
        }, token, (progress) => {
            this.setState({ uploadProgress: Math.round(progress) });
        });
        };

        const policyname = this.props.cookies.cookies.policyname;
        if (policyname !== 'admin') {
            const summaryError = this._checkSummaryQuota(emacCount);
            if (summaryError) {
                Message.error(summaryError, 8, { position: 'bottom-right' });
                return;
            }
        }

        if (policyname === 'admin') {
            doUpload();
        } else {
            getPO(vendor, (poData) => {
                if (poData && poData.po) {
                    const poEntry = poData.po.find(p => p.attribute === primaryAttr);
                    if (poEntry && poEntry.remaining <= 0) {
                        Message.error(
                            `No remaining ${primaryAttr} licenses for ${vendor}. Current balance: ${poEntry.remaining.toLocaleString()}`,
                            5, { position: 'bottom-right' }
                        );
                        return;
                    }
                    if (poEntry && emacCount > poEntry.remaining) {
                        Message.error(
                            `Cannot upload ${emacCount.toLocaleString()} EMACs — only ${poEntry.remaining.toLocaleString()} ${primaryAttr} licenses remaining for ${vendor}`,
                            5, { position: 'bottom-right' }
                        );
                        return;
                    }
                }
                doUpload();
            });
        }
    }

    downloadPreviewDuplicatesCSV = () => {
        const { previewDuplicateMacs, batch_name, batch_description, brand, mboard, model, vendor, factory, features } = this.state;
        if (!previewDuplicateMacs || previewDuplicateMacs.length === 0) {
            Message.error('No duplicate data available', 3, { position: 'bottom-right' });
            return;
        }
        const toMac = mac => mac ? mac.replace(/[:\-]/g,'').toUpperCase().match(/.{1,2}/g).join(':') : '';
        const esc   = v  => (v  || '').replace(/"/g, '""');

        const formBrand    = esc(brand);
        const formBoard    = esc(boardName(mboard));
        const formModel    = esc(model);
        const formVendor   = esc(vendor);
        const formFactory  = esc(factory);
        const formFeatures = esc(Array.isArray(features) ? features.join(', ') : (features || ''));
        const formDesc     = esc(batch_description || batch_name);

        const lines = ['MAC Address,Brand,Board,Model,Vendor,Factory,Description,Serial No,Features'];
        previewDuplicateMacs.forEach((row, i) => {
            const emac   = esc(toMac(row.emac));
            const serial = esc(row.serialno || String(i + 1).padStart(2, '0'));
            lines.push(`"${emac}","${formBrand}","${formBoard}","${formModel}","${formVendor}","${formFactory}","${formDesc}","${serial}","${formFeatures}"`);
        });

        const csv  = lines.join('\n') + '\n';
        const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
        const url  = window.URL.createObjectURL(blob);
        const a    = document.createElement('a');
        a.href     = url;
        a.download = `duplicates_preview_${batch_name || 'mac_addresses'}.csv`;
        document.body.appendChild(a);
        a.click();
        window.URL.revokeObjectURL(url);
        document.body.removeChild(a);
        Message.success(`${previewDuplicateMacs.length} duplicate MACs downloaded!`, 4, { position: 'bottom-right' });
    }

    downloadDuplicateRowsCSV = () => {
        const { duplicateRows, batch_name, batch_description, brand, mboard, model, vendor, factory, features } = this.state;
        if (!duplicateRows || duplicateRows.length === 0) {
            Message.error('No duplicate data available', 3, { position: 'bottom-right' });
            return;
        }

        const toMac = mac => mac ? mac.replace(/[:\-]/g,'').toUpperCase().match(/.{1,2}/g).join(':') : '';
        const esc   = v  => (v  || '').replace(/"/g, '""');

        const cleanBoard = boardName(mboard);

        const formBrand    = esc(brand);
        const formBoard    = esc(cleanBoard);
        const formModel    = esc(model);
        const formVendor   = esc(vendor);
        const formFactory  = esc(factory);
        const formFeatures = esc(Array.isArray(features) ? features.join(', ') : (features || ''));

        const lines = ['MAC Address,Brand,Board,Model,Vendor,Factory,Description,Serial No,Features'];
        duplicateRows.forEach(row => {
            const emac   = esc(toMac(row.emac));
            const serial = esc(row.serialno);
            const desc   = esc(row.description || batch_description || batch_name);
            lines.push(`"${emac}","${formBrand}","${formBoard}","${formModel}","${formVendor}","${formFactory}","${desc}","${serial}","${formFeatures}"`);
        });

        const csv  = lines.join('\n') + '\n';
        const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
        const url  = window.URL.createObjectURL(blob);
        const a    = document.createElement('a');
        a.href     = url;
        a.download = `duplicates_${batch_name || 'mac_addresses'}.csv`;
        document.body.appendChild(a);
        a.click();
        window.URL.revokeObjectURL(url);
        document.body.removeChild(a);
        Message.success(`${duplicateRows.length} duplicate MACs downloaded!`, 4, { position: 'bottom-right' });
    }

    _downloadCSVFromLocal = () => {
        const { uploadedFileData, xlsx_data, batch_description, batch_name, uploadedFileName } = this.state;
        const rows = uploadedFileData || xlsx_data || [];
        if (rows.length === 0) {
            Message.error('No data available to download', 3, { position: 'bottom-right' });
            this.setState({ isExporting: false });
            return;
        }
        const lines = ['emac,serialno,description'];
        rows.forEach(row => {
            const desc = (row.description || batch_description || '').replace(/"/g, '""');
            const emac = (row.emac || '').replace(/"/g, '""');
            const serial = (row.serialno || '').replace(/"/g, '""');
            lines.push(`"${emac}","${serial}","${desc}"`);
        });
        const blob = new Blob([lines.join('\n') + '\n'], { type: 'text/csv;charset=utf-8;' });
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = `uploaded_${uploadedFileName || batch_name || 'mac_addresses'}.csv`;
        document.body.appendChild(a);
        a.click();
        window.URL.revokeObjectURL(url);
        document.body.removeChild(a);
        this.setState({ isExporting: false });
        Message.success('CSV downloaded successfully!', 4, { position: 'bottom-right' });
    }

    downloadUploadedCSV = () => {
        const { downloadSessionInfo, uploadedFileData, xlsx_data } = this.state;

        if (!downloadSessionInfo) {
            Message.error('No download information available', 3, { position: 'bottom-right' });
            return;
        }

        this.setState({ isExporting: true });

        let queryParams = [];

        if (downloadSessionInfo.session_id) {
            queryParams.push(`session_id=${encodeURIComponent(downloadSessionInfo.session_id)}`);
        }

        if (downloadSessionInfo.batch_id) {
            queryParams.push(`batch_id=${encodeURIComponent(downloadSessionInfo.batch_id)}`);
        }

        const batchNameValue = downloadSessionInfo.batch_name;
        if (batchNameValue) {
            queryParams.push(`batch_name=${encodeURIComponent(batchNameValue)}`);
        }

        const queryString = queryParams.length > 0 ? `?${queryParams.join('&')}` : '';
        const exportUrl = `/lm/v1/csvbundle_uploader/export-csv${queryString}`;
        const token = this.props.cookies.cookies.token;

        fetch(exportUrl, {
            method: 'GET',
            headers: {
                ...(token ? { 'Authorization': `Bearer ${token}` } : {}),
                'Accept': 'text/csv',
            },
            credentials: 'include'
        })
            .then(response => {
                const contentDisposition = response.headers.get('Content-Disposition');
                let filename = 'mac_addresses.csv';
                if (contentDisposition) {
                    const filenameMatch = contentDisposition.match(/filename="(.+)"/);
                    if (filenameMatch && filenameMatch[1]) filename = filenameMatch[1];
                }
                return response.text().then(text => ({ text, filename }));
            })
            .then(({ text, filename }) => {
                // If backend returns a JSON error, fall back to local generation
                try {
                    const parsed = JSON.parse(text);
                    if (parsed.status === 'error' || parsed.message) {
                        this._downloadCSVFromLocal();
                        return;
                    }
                } catch (_) {}

                // Valid CSV — download it
                const blob = new Blob([text], { type: 'text/csv;charset=utf-8;' });
                const url = window.URL.createObjectURL(blob);
                const a = document.createElement('a');
                a.href = url;
                a.download = filename;
                document.body.appendChild(a);
                a.click();
                window.URL.revokeObjectURL(url);
                document.body.removeChild(a);
                this.setState({ isExporting: false });
                Message.success(`CSV file '${filename}' downloaded successfully!`, 4, { position: 'bottom-right' });
            })
            .catch(() => {
                this._downloadCSVFromLocal();
            });
    }

    handleDownloadAndReset = () => {
        this.downloadUploadedCSV();

        setTimeout(() => {
            this.resetForm();
        }, 3000);
    }

    resetForm = () => {
        console.log("Resetting form...");

        const resetState = {
            brand: '',
            mboard: '',
            vendor: '',
            factory: '',
            model: '',
            features: [],
            attributes: [],
            xlsx_data: [],
            data: [],
            table: '',
            fileAnalysis: null,
            fileErrors: [],
            uploadedFileData: null,
            uploadedFileName: null,
            duplicateCount: 0,
            uniqueCount: 0,
            invalidCount: 0,
            allDuplicates: false,
            start_mac: '',
            end_mac: '',
            batch_name: '',
            batch_description: '',
            previewCount: 0,
            previewStart: '',
            previewEnd: '',
            macValidation: { isValid: false, message: '' },
            formErrors: {},
            isFormValid: false,
            isUploading: false,
            uploadProgress: 0,
            uploadProcessed: 0,
            uploadTotal: 0,
            uploadStatus: null,
            uploadResult: null,
            showResultDialog: false,
            showConfirmUpload: false,
            isAnalyzingPreview: false,
            previewData: null,
            showPreviewDialog: false,
            previewSummary: null,
            previewDuplicateMacs: [],
            isExporting: false,
            lastSessionId: null,
            lastBatchId: null,
            showDownloadOption: false,
            downloadSessionInfo: null,
            validationErrors: null,
            showValidationDialog: false,
            uploadErrorMessage: null,
            duplicateRows: [],
            uniqueRows: [],
            showDuplicateDialog: false,
            uploadMode: 'csv',
            macPreviewData: null,
            isGeneratingMacPreview: false,
            touched: {},
            formResetKey: this.state.formResetKey + 1,
            uploadKey: this.state.uploadKey + 1,
            activePanel: null,
        };

        this.setState(resetState, () => {
            console.log("Form reset complete");
            Message.success('Form has been reset successfully', 3, { position: 'bottom-right' });

            setTimeout(() => {
                this.forceUpdate();
            }, 100);
        });
    }

    handleFileRemove = () => {
        this.setState(prev => ({
            uploadedFileData: null,
            uploadedFileName: null,
            xlsx_data: [],
            fileErrors: [],
            validationErrors: null,
            showValidationDialog: false,
            allDuplicates: false,
            uploadErrorMessage: null,
            batch_description: '',
            batch_name: '',
            touched: { ...prev.touched, file: false },
            uploadKey: prev.uploadKey + 1,
        }), () => {
            this.validateForm();
        });
    }

    downloadTemplateCSV = () => {
        const rows = [
            'EMAC,SERIALNO,DESCRIPTION',
            'EMAC_IN_CAPS,SERIAL_NO_VALUE,DESCRIPTION_IF_NECESSARY',
        ];
        const blob = new Blob([rows.join('\n') + '\n'], { type: 'text/csv;charset=utf-8;' });
        const url = URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = 'bundle_upload_template.csv';
        document.body.appendChild(a);
        a.click();
        URL.revokeObjectURL(url);
        document.body.removeChild(a);
    }

    downloadPreviewReport = () => {
        const { previewData, previewSummary } = this.state;

        if (!previewData || !previewSummary) {
            Message.error('No preview data available', 3, { position: 'bottom-right' });
            return;
        }

        let reportContent = `Upload Preview Report\n`;
        reportContent += `Generated: ${new Date().toLocaleString()}\n`;
        reportContent += `=================================\n\n`;

        reportContent += `${previewSummary.title}\n`;
        reportContent += `=================================\n`;

        previewSummary.items.forEach(item => {
            reportContent += `${item.label}: ${item.value}\n`;
        });

        reportContent += `\n${previewSummary.message}\n\n`;

        if (previewData.sample_data) {
            reportContent += `Sample MAC Addresses:\n`;
            reportContent += `=================================\n`;
            previewData.sample_data.forEach(item => {
                reportContent += `${item.emac} - ${item.status}\n`;
            });
        }

        const blob = new Blob([reportContent], { type: 'text/plain' });
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = `upload_preview_${new Date().getTime()}.txt`;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        window.URL.revokeObjectURL(url);

        Message.success('Preview report downloaded', 3, { position: 'bottom-right' });
    }

    render() {
        const { classes } = this.props;
        const {
            uploadMode,
            previewCount,
            previewStart,
            previewEnd,
            brands,
            boards,
            vendors,
            factorys,
            featuresList,
            start_mac,
            end_mac,
            brand,
            mboard,
            vendor,
            factory,
            batch_name,
            batch_description,
            model,
            fileAnalysis,
            isUploading,
            uploadProgress,
            uploadStatus,
            uploadResult,
            showResultDialog,
            formErrors,
            isFormValid,
            POST,
            isExporting,
            downloadSessionInfo,
            formResetKey,
            uploadKey,
            showDownloadOption,
            isAnalyzingPreview,
            previewData,
            showPreviewDialog,
            previewSummary,
            validationErrors,
            showValidationDialog,
            uploadedFileData,
            uploadedFileName,
            uploadErrorMessage,
            touched,
            macPreviewData,
            isGeneratingMacPreview,
            activePanel,
            duplicateRows,
            uniqueRows,
            showDuplicateDialog,
            allDuplicates,
            fileErrors,
        } = this.state;

        if (this.state.isLoading) {
            return (
                <div className={classes.loadingOverlay}>
                    <CircularProgress size={60} />
                    <Typography className={classes.loadingText}>Loading Bundle Uploader...</Typography>
                </div>
            );
        }

        return (
            <React.Fragment>
                {isUploading && (
                    <div className={classes.loadingOverlay}>
                        <CircularProgress size={80} />
                        <Typography className={classes.loadingText}>
                            {uploadProgress === 100
                                ? 'Complete!'
                                : this.state.uploadTotal > 0
                                    ? `Inserting ${this.state.uploadProcessed} / ${this.state.uploadTotal} MACs...`
                                    : uploadProgress > 0
                                        ? `Processing... ${uploadProgress}%`
                                        : (uploadMode === 'macrange' ? 'Uploading MAC Range...' : 'Uploading CSV Data...')}
                        </Typography>
                        <LinearProgress
                            variant="determinate"
                            value={uploadProgress}
                            style={{ width: '300px', height: '8px', borderRadius: '4px' }}
                        />
                        <Typography variant="body2" color="textSecondary">
                            {Math.floor(uploadProgress)}%
                        </Typography>
                    </div>
                )}

             <Dialog
    open={showValidationDialog}
    onClose={() => this.setState({ showValidationDialog: false })}
    maxWidth="md"
    fullWidth
    scroll="paper"
    style={{ zIndex: 1400 }}
>
    <DialogTitle>
        <Typography variant="h6" style={{ display: 'flex', alignItems: 'center', gap: '8px', color: '#d32f2f' }}>
            <ErrorOutline />
            File Validation Failed
        </Typography>
        <Typography variant="subtitle2" color="textSecondary">
            Found {validationErrors?.length || 0} issue(s). Please fix these and upload again.
        </Typography>
    </DialogTitle>

    <DialogContent dividers>
        {validationErrors && validationErrors.length > 0 && (
            <div className={classes.errorTableContainer}>
                <MaterialTable
                    title="Validation Issues"
                    columns={[
                        { 
                            title: 'Row', 
                            field: 'row', 
                            width: '60px',
                            cellStyle: { fontSize: '12px' } 
                        },
                        { 
                            title: 'EMAC', 
                            field: 'emac', 
                            cellStyle: { fontSize: '12px' } 
                        },
                        { 
                            title: 'SERIAL NO', 
                            field: 'serialno', 
                            cellStyle: { fontSize: '12px' } 
                        },
                        { 
                            title: 'DESCRIPTION', 
                            field: 'description', 
                            cellStyle: { fontSize: '12px' } 
                        },
                        { 
                            title: 'ERROR', 
                            field: 'error_message', 
                            cellStyle: { color: '#d32f2f', fontWeight: 'bold', fontSize: '12px' } 
                        },
                    ]}
                    data={validationErrors.map((err, idx) => ({
                        ...err,
                        row: err.row || idx + 1
                    }))}
                    options={{
                        pageSize: Math.min(validationErrors.length, 25),
                        pageSizeOptions: [10, 25, 50, 100],
                        padding: "dense",
                        exportButton: true,
                        exportFileName: "file_validation_errors",
                        maxBodyHeight: '400px',
                        toolbar: true
                    }}
                    localization={{
                        header: {
                            actions: 'Actions'
                        },
                        body: {
                            emptyDataSourceMessage: 'No validation errors found'
                        }
                    }}
                />
                
                {/* Add summary of issues */}
                <Alert severity="error" style={{ marginTop: '16px' }}>
                    <Typography variant="body2">
                        <strong>Summary:</strong> Please review the {validationErrors.length} issues above.
                        Fix the MAC addresses in your file and try uploading again.
                    </Typography>
                </Alert>
            </div>
        )}
    </DialogContent>

    <DialogActions>
        <button
            onClick={() => this.setState({ showValidationDialog: false })}
            className={classes.modernButton}
            style={{ backgroundColor: '#1976d2' }}
        >
            Close
        </button>
    </DialogActions>
</Dialog>

{/* ── Duplicate + Unique split dialog (errorCode 108) ── */}
<Dialog
    open={showDuplicateDialog}
    onClose={() => this.setState({ showDuplicateDialog: false })}
    maxWidth="md"
    fullWidth
    scroll="paper"
    style={{ zIndex: 1400 }}
>
    <DialogTitle>
        <Typography variant="h6" style={{ display: 'flex', alignItems: 'center', gap: '8px', color: '#f57c00' }}>
            <InfoOutlined />
            Duplicate MACs Detected
        </Typography>
        <Typography variant="subtitle2" color="textSecondary">
            {duplicateRows.length} MAC(s) already exist in the database.
            {uniqueRows.length > 0 ? ` ${uniqueRows.length} unique MAC(s) can still be uploaded.` : ' No new MACs to upload.'}
        </Typography>
    </DialogTitle>
    <DialogContent dividers>
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '16px' }}>
            {/* Duplicate list */}
            <div>
                <Typography variant="subtitle1" style={{ fontWeight: 700, color: '#d32f2f', marginBottom: '8px' }}>
                    Duplicates ({duplicateRows.length})
                </Typography>
                <div style={{ maxHeight: '300px', overflowY: 'auto', border: '1px solid #ef9a9a', borderRadius: '6px' }}>
                    <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '12px' }}>
                        <thead>
                            <tr style={{ backgroundColor: '#ffebee', position: 'sticky', top: 0 }}>
                                <th style={{ padding: '6px 8px', textAlign: 'left', color: '#c62828' }}>EMAC</th>
                                <th style={{ padding: '6px 8px', textAlign: 'left', color: '#c62828' }}>Serial No</th>
                            </tr>
                        </thead>
                        <tbody>
                            {duplicateRows.map((row, idx) => (
                                <tr key={idx} style={{ backgroundColor: idx % 2 === 0 ? '#fff' : '#fff8f8', borderBottom: '1px solid #ffcdd2' }}>
                                    <td style={{ padding: '5px 8px', fontFamily: 'monospace' }}>{row.emac}</td>
                                    <td style={{ padding: '5px 8px' }}>{row.serialno || '—'}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </div>
            {/* Unique list */}
            <div>
                <Typography variant="subtitle1" style={{ fontWeight: 700, color: '#2e7d32', marginBottom: '8px' }}>
                    Unique — will be uploaded ({uniqueRows.length})
                </Typography>
                <div style={{ maxHeight: '300px', overflowY: 'auto', border: '1px solid #a5d6a7', borderRadius: '6px' }}>
                    {uniqueRows.length === 0 ? (
                        <div style={{ padding: '16px', color: '#888', textAlign: 'center' }}>No unique MACs</div>
                    ) : (
                        <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '12px' }}>
                            <thead>
                                <tr style={{ backgroundColor: '#e8f5e9', position: 'sticky', top: 0 }}>
                                    <th style={{ padding: '6px 8px', textAlign: 'left', color: '#1b5e20' }}>EMAC</th>
                                    <th style={{ padding: '6px 8px', textAlign: 'left', color: '#1b5e20' }}>Serial No</th>
                                </tr>
                            </thead>
                            <tbody>
                                {uniqueRows.slice(0, 200).map((row, idx) => (
                                    <tr key={idx} style={{ backgroundColor: idx % 2 === 0 ? '#fff' : '#f9fbe7', borderBottom: '1px solid #c8e6c9' }}>
                                        <td style={{ padding: '5px 8px', fontFamily: 'monospace' }}>{row.emac}</td>
                                        <td style={{ padding: '5px 8px' }}>{row.serialno || '—'}</td>
                                    </tr>
                                ))}
                                {uniqueRows.length > 200 && (
                                    <tr><td colSpan={2} style={{ padding: '6px 8px', color: '#558b2f', textAlign: 'center', fontSize: '11px' }}>
                                        Showing 200 of {uniqueRows.length} unique MACs
                                    </td></tr>
                                )}
                            </tbody>
                        </table>
                    )}
                </div>
            </div>
        </div>
    </DialogContent>
    <DialogActions style={{ padding: '16px 24px', gap: '12px' }}>
        <button
            onClick={() => this.setState({ showDuplicateDialog: false, duplicateRows: [], uniqueRows: [], fileErrors: [] })}
            className={classes.modernButton}
            style={{ backgroundColor: '#6c757d' }}
        >
            Cancel
        </button>
        {duplicateRows.length > 0 && (
            <button
                onClick={this.downloadDuplicateRowsCSV}
                className={classes.modernButton}
                style={{ backgroundColor: '#f57c00' }}
            >
                <GetApp fontSize="small" style={{ marginRight: '6px' }} />
                Download Duplicates ({duplicateRows.length})
            </button>
        )}
        {uniqueRows.length > 0 && (
            <button
                onClick={() => {
                    this.setState({
                        uploadedFileData: uniqueRows,
                        xlsx_data: uniqueRows,
                        uploadedFileName: 'unique_macs',
                        showDuplicateDialog: false,
                        duplicateRows: [],
                        uniqueRows: [],
                        uploadErrorMessage: null,
                        touched: { ...this.state.touched, file: true },
                    }, () => {
                        this.validateForm();
                        Message.success(`Loaded ${uniqueRows.length} unique MACs. Proceed to upload.`, 4, { position: 'bottom-right' });
                    });
                }}
                className={classes.modernButton}
                style={{ backgroundColor: '#2e7d32' }}
            >
                <CloudUpload fontSize="small" style={{ marginRight: '6px' }} />
                confirm {uniqueRows.length} Unique MACs
            </button>
        )}
    </DialogActions>
</Dialog>

                <Card fullWidth className={classes.card}>
                    <Card.Header style={{ fontSize: '24px', fontWeight: 600, color: '#1976d2', marginBottom: '20px' }}>
                        BUNDLE UPLOADER
                    </Card.Header>


                    {POST ? (
                        <Card.Body>
                            <Form
                                key={formResetKey}
                                scrollToError={30}
                                onSubmit={(e) => {
                                    e.preventDefault();
                                    this.handleSubmit();
                                }}
                            >
                                {uploadStatus === 'success' && uploadResult && (
                                    <div style={{
                                        padding: '28px', backgroundColor: '#f1f8e9',
                                        borderRadius: '12px', border: '2px solid #a5d6a7',
                                        margin: '0 0 24px 0', textAlign: 'center',
                                    }}>
                                        <CheckCircleOutline style={{ fontSize: '52px', color: '#2e7d32', marginBottom: '12px' }} />
                                        <Typography variant="h5" style={{ fontWeight: 700, color: '#1b5e20', marginBottom: '8px' }}>
                                            Upload Successful!
                                        </Typography>
                                        {uploadResult.inserted_count > 0 && (
                                            <Typography variant="body1" style={{ color: '#388e3c', marginBottom: '24px' }}>
                                                <strong>{uploadResult.inserted_count}</strong> MAC addresses were activated.
                                            </Typography>
                                        )}

                                        <div style={{ display: 'flex', gap: '16px', justifyContent: 'center', flexWrap: 'wrap' }}>
                                            <button
                                                onClick={this.downloadUploadedCSV}
                                                disabled={isExporting}
                                                style={{
                                                    display: 'inline-flex', alignItems: 'center', gap: '8px',
                                                    padding: '12px 28px', borderRadius: '8px', border: 'none',
                                                    backgroundColor: isExporting ? '#b0bec5' : '#1976d2',
                                                    color: '#fff', fontWeight: 600, fontSize: '15px',
                                                    cursor: isExporting ? 'not-allowed' : 'pointer',
                                                    boxShadow: '0 2px 8px rgba(25,118,210,0.3)',
                                                }}
                                            >
                                                {isExporting
                                                    ? <><CircularProgress size={16} style={{ color: '#fff' }} /> Downloading...</>
                                                    : <><GetApp /> Download CSV</>}
                                            </button>

                                            <button
                                                onClick={() => window.location.reload()}
                                                style={{
                                                    display: 'inline-flex', alignItems: 'center', gap: '8px',
                                                    padding: '12px 28px', borderRadius: '8px', border: '2px solid #6c757d',
                                                    backgroundColor: 'transparent', color: '#6c757d',
                                                    fontWeight: 600, fontSize: '15px', cursor: 'pointer',
                                                }}
                                            >
                                                <Refresh /> Reload
                                            </button>
                                        </div>
                                    </div>
                                )}

                                {uploadStatus !== 'success' && (
                                    <Alert type="info" icon style={{ marginBottom: '24px', borderRadius: '8px' }}>
                                        Fill in the device details, then either upload a CSV/XLSX file (left) or enter a MAC range (right). Click "Preview Upload" to validate before submission.
                                    </Alert>
                                )}

                                {uploadStatus !== 'success' && uploadMode === 'csv' && uploadedFileData && uploadedFileData.length > 0 && (
                                    <Alert type="success" icon style={{ marginBottom: '20px', borderRadius: '8px' }}>
                                        <strong>File loaded:</strong> {uploadedFileData.length} entries ready.
                                        Click "Preview Upload" to validate and continue.
                                    </Alert>
                                )}

                                {uploadStatus !== 'success' && uploadMode === 'csv' && fileAnalysis && (
                                    <div className={classes.formSection}>
                                        <Typography className={classes.formSectionTitle}>
                                            <InfoOutlined />
                                            File Analysis Results
                                        </Typography>
                                        <div className={classes.statsContainer}>
                                            <div className={classes.statCard}>
                                                <div className={classes.statValue}>{fileAnalysis.totalEntries.toLocaleString()}</div>
                                                <div className={classes.statLabel}>Total Entries</div>
                                            </div>
                                            <div className={classes.statCard}>
                                                <div className={`${classes.statValue} ${classes.statPositive}`}>
                                                    {fileAnalysis.uniqueCount.toLocaleString()}
                                                </div>
                                                <div className={classes.statLabel}>Unique MACs</div>
                                            </div>
                                            <div className={classes.statCard}>
                                                <div className={`${classes.statValue}`} style={{ color: '#f57c00' }}>
                                                    {fileAnalysis.duplicateCount.toLocaleString()}
                                                </div>
                                                <div className={classes.statLabel}>Duplicates</div>
                                            </div>
                                            <div className={classes.statCard}>
                                                <div className={`${classes.statValue} ${classes.statNegative}`}>
                                                    {fileAnalysis.invalidCount.toLocaleString()}
                                                </div>
                                                <div className={classes.statLabel}>Invalid</div>
                                            </div>
                                        </div>
                                    </div>
                                )}

                                {/* {uploadStatus !== 'success' && uploadMode === 'macrange' && previewCount > 0 && (
                                    <div className={classes.previewCard}>
                                        <Typography variant="h6" style={{ color: '#1976d2', marginBottom: '12px' }}>
                                            Range Preview
                                        </Typography>
                                        <div className={classes.statsContainer}>
                                            <div className={classes.statCard}>
                                                <div className={classes.statValue}>{previewCount.toLocaleString()}</div>
                                                <div className={classes.statLabel}>Total MACs</div>
                                            </div>
                                            <div className={classes.statCard}>
                                                <div className={classes.statValue}>{previewStart}</div>
                                                <div className={classes.statLabel}>Start MAC</div>
                                            </div>
                                            <div className={classes.statCard}>
                                                <div className={classes.statValue}>{previewEnd}</div>
                                                <div className={classes.statLabel}>End MAC</div>
                                            </div>
                                        </div>
                                    </div>
                                )} */}

                                {uploadStatus !== 'success' && (
                                    <React.Fragment>
                                        {/* ── Device + Manufacturing cards ── */}
                                        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '36px', marginBottom: '28px' }}>

                                            {/* Device Information */}
                                            <div style={{ border: '1px solid #e8e8e8', borderRadius: '12px', background: '#fff' }}>
                                                <div style={{ padding: '14px 20px', borderBottom: '1px solid #f0f0f0', background: '#fafafa', borderRadius: '12px 12px 0 0' }}>
                                                    <h3 style={{ margin: 0, fontSize: '15px', fontWeight: 700, color: '#222' }}>Device Information</h3>
                                                </div>
                                                <div style={{ padding: '20px', display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '16px' }}>
                                                    <div>
                                                        <label style={{ display: 'block', fontSize: '13px', fontWeight: 600, color: '#444', marginBottom: '6px' }}>
                                                            Brand <span style={{ color: '#e53e3e' }}>*</span>
                                                        </label>
                                                        <Select
                                                            key={`brand-${formResetKey}`}
                                                            name="brand"
                                                            data={brands}
                                                            value={brand}
                                                            onChange={this.handleBrandChange}
                                                            clearable
                                                            keygen
                                                            onFilter={text => d => d.indexOf(text) >= 0}
                                                            placeholder="Select Brand"
                                                            style={{ width: '100%' }}
                                                        />
                                                        {touched.brand && formErrors.brand && <Typography color="error" variant="caption">{formErrors.brand}</Typography>}
                                                    </div>

                                                    <div>
                                                        <label style={{ display: 'block', fontSize: '13px', fontWeight: 600, color: '#444', marginBottom: '6px' }}>
                                                            Board <span style={{ color: '#e53e3e' }}>*</span>
                                                        </label>
                                                        <Select
                                                            key={`board-${formResetKey}`}
                                                            name="mboard"
                                                            data={boards}
                                                            value={mboard}
                                                            onChange={value => { this.setState({ mboard: value }, () => { this.markTouched('mboard'); this.validateForm(); }); }}
                                                            clearable
                                                            keygen
                                                            onFilter={text => d => d.indexOf(text) >= 0}
                                                            placeholder="Select Board"
                                                            style={{ width: '100%' }}
                                                        />
                                                        {touched.mboard && formErrors.mboard && <Typography color="error" variant="caption">{formErrors.mboard}</Typography>}
                                                    </div>

                                                    <div>
                                                        <label style={{ display: 'block', fontSize: '13px', fontWeight: 600, color: '#444', marginBottom: '6px' }}>Features</label>
                                                        <Select
                                                            key={`features-${formResetKey}`}
                                                            name="features"
                                                            data={featuresList}
                                                            value={this.state.features}
                                                            onChange={value => { this.setState({ features: value, attributes: this.computeAttributes(this.state.brand, value) }, () => { this.markTouched('features'); this.validateForm(); }); }}
                                                            clearable
                                                            keygen
                                                            onFilter={text => d => d.toLowerCase().indexOf(text.toLowerCase()) >= 0}
                                                            multiple
                                                            placeholder="Select Features"
                                                            style={{ width: '100%' }}
                                                        />
                                                        {touched.features && formErrors.features && <Typography color="error" variant="caption">{formErrors.features}</Typography>}
                                                    </div>

                                                    <div>
                                                        <label style={{ display: 'block', fontSize: '13px', fontWeight: 600, color: '#444', marginBottom: '6px' }}>Model <span style={{ color: '#d32f2f' }}>*</span></label>
                                                        <Input
                                                            key={`model-${formResetKey}`}
                                                            name="model"
                                                            value={model}
                                                            onChange={value => { this.setState({ model: value }, () => { this.markTouched('model'); this.validateForm(); }); }}
                                                            placeholder="e.g., 43UH-G"
                                                            style={{ width: '100%' }}
                                                        />
                                                        {touched.model && formErrors.model && <Typography color="error" variant="caption">{formErrors.model}</Typography>}
                                                    </div>

                                                    {/* Attribute — auto-selected from brand, read-only */}
                                                    {/* <div style={{ gridColumn: '1 / -1' }}>
                                                        <label style={{ display: 'block', fontSize: '13px', fontWeight: 600, color: '#444', marginBottom: '6px' }}>
                                                            Attribute <span style={{ color: '#888', fontWeight: 400 }}>(auto-detected from brand)</span>
                                                        </label>
                                                        <div style={{
                                                            display: 'flex', alignItems: 'center', gap: '10px',
                                                            padding: '8px 12px', borderRadius: '6px',
                                                            border: '1px solid #e0e0e0', backgroundColor: '#f5f5f5',
                                                            minHeight: '36px',
                                                        }}>
                                                            {this.state.attributes && this.state.attributes.length > 0 ? (
                                                                this.state.attributes.map((attr, i) => (
                                                                    <span key={i} style={{
                                                                        padding: '3px 10px', borderRadius: '12px', fontSize: '12px', fontWeight: 700,
                                                                        backgroundColor: attr === 'LITE_OS' ? '#fff3e0' : '#e8f5e9',
                                                                        color: attr === 'LITE_OS' ? '#e65100' : '#1b5e20',
                                                                        border: `1px solid ${attr === 'LITE_OS' ? '#ffb74d' : '#81c784'}`,
                                                                    }}>
                                                                        {attr}
                                                                    </span>
                                                                ))
                                                            ) : (
                                                                <span style={{ color: '#aaa', fontSize: '13px' }}>
                                                                    Select a brand to auto-detect
                                                                </span>
                                                            )}
                                                        </div>
                                                    </div> */}
                                                </div>
                                            </div>

                                            {/* Manufacturing Information */}
                                            <div style={{ border: '1px solid #e8e8e8', borderRadius: '12px', background: '#fff' }}>
                                                <div style={{ padding: '14px 20px', borderBottom: '1px solid #f0f0f0', background: '#fafafa', borderRadius: '12px 12px 0 0' }}>
                                                    <h3 style={{ margin: 0, fontSize: '15px', fontWeight: 700, color: '#222' }}>Manufacturing Information</h3>
                                                </div>
                                                <div style={{ padding: '20px', display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '16px' }}>
                                                    <div>
                                                        <label style={{ display: 'block', fontSize: '13px', fontWeight: 600, color: '#444', marginBottom: '6px' }}>
                                                            Vendor <span style={{ color: '#e53e3e' }}>*</span>
                                                        </label>
                                                        <Select
                                                            key={`vendor-${formResetKey}`}
                                                            name="vendor"
                                                            data={vendors}
                                                            value={vendor}
                                                            onChange={value => { this.setState({ vendor: value }, () => { this.markTouched('vendor'); this.validateForm(); }); }}
                                                            clearable
                                                            keygen
                                                            onFilter={text => d => d.indexOf(text) >= 0}
                                                            placeholder="Select Vendor"
                                                            style={{ width: '100%' }}
                                                        />
                                                        {touched.vendor && formErrors.vendor && <Typography color="error" variant="caption">{formErrors.vendor}</Typography>}
                                                    </div>

                                                    <div>
                                                        <label style={{ display: 'block', fontSize: '13px', fontWeight: 600, color: '#444', marginBottom: '6px' }}>
                                                            Factory <span style={{ color: '#e53e3e' }}>*</span>
                                                        </label>
                                                        <Select
                                                            key={`factory-${formResetKey}`}
                                                            name="factory"
                                                            data={factorys}
                                                            value={factory}
                                                            onChange={value => { this.setState({ factory: value }, () => { this.markTouched('factory'); this.validateForm(); }); }}
                                                            clearable
                                                            keygen
                                                            onFilter={text => d => d.indexOf(text) >= 0}
                                                            placeholder="Select Factory"
                                                            style={{ width: '100%' }}
                                                        />
                                                        {touched.factory && formErrors.factory && <Typography color="error" variant="caption">{formErrors.factory}</Typography>}
                                                    </div>

                                                    

                                                    <div>
                                                        <label style={{ display: 'block', fontSize: '13px', fontWeight: 600, color: '#444', marginBottom: '6px' }}>
                                                            Description <span style={{ color: '#aaa', fontWeight: 400 }}>(optional — used when CSV row has no description)</span>
                                                        </label>
                                                        <Input
                                                            key={`batch-desc-${formResetKey}`}
                                                            name="batch_description"
                                                            value={batch_description}
                                                            onChange={value => this.setState({ batch_description: value })}
                                                            placeholder="add information"
                                                            style={{ width: '100%' }}
                                                        />
                                                    </div>
                                                </div>
                                            </div>

                                        </div>

                                        {/* ── Upload Method ── */}
                                        <div style={{ display: 'flex', alignItems: 'stretch', border: '1px solid #e8e8e8', borderRadius: '12px', overflow: 'hidden', background: '#fff', marginBottom: '20px' }}>

                                            {/* Left: CSV Upload */}
                                            <div
                                                onClick={() => this.setState({ activePanel: 'csv' })}
                                                style={{ flex: 1, padding: '24px', display: 'flex', flexDirection: 'column', gap: '14px' }}
                                            >
                                                <p style={{ margin: 0, fontSize: '13px', color: '#888', fontWeight: 500 }}>Have a file ready?</p>

                                                {/* File card — success or error — shown outside Upload so Remove is always clickable */}
                                                {uploadedFileData && uploadedFileData.length > 0 && !uploadErrorMessage ? (
                                                    <div style={{
                                                        display: 'flex', alignItems: 'center', gap: '12px',
                                                        border: '2px solid #66bb6a', borderRadius: '10px',
                                                        padding: '16px 20px', backgroundColor: '#f0fff4',
                                                    }}>
                                                        <CheckCircleOutline style={{ color: '#2e7d32', fontSize: '28px', flexShrink: 0 }} />
                                                        <div style={{ flex: 1, overflow: 'hidden' }}>
                                                            <div style={{ fontWeight: 700, fontSize: '13px', color: '#1b5e20', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                                                                {uploadedFileName || 'File loaded'}
                                                            </div>
                                                            <div style={{ fontSize: '12px', color: '#388e3c' }}>
                                                                {uploadedFileData.length} entries ready
                                                            </div>
                                                        </div>
                                                        <button type="button" onClick={this.handleFileRemove} style={{ display: 'inline-flex', alignItems: 'center', gap: '4px', background: '#ffebee', border: '1px solid #ef9a9a', borderRadius: '6px', cursor: 'pointer', color: '#c62828', fontSize: '12px', fontWeight: 600, padding: '6px 14px', flexShrink: 0 }}>
                                                            ✕ Remove
                                                        </button>
                                                    </div>
                                                ) : uploadErrorMessage ? (
                                                    <div style={{ display: 'flex', alignItems: 'center', gap: '12px', border: '2px solid #ef9a9a', borderRadius: '10px', padding: '14px 16px', backgroundColor: '#fff5f5' }}>
                                                        <ErrorOutline style={{ color: '#c62828', fontSize: '24px', flexShrink: 0 }} />
                                                        <div style={{ flex: 1, overflow: 'hidden' }}>
                                                            <div style={{ fontWeight: 700, fontSize: '13px', color: '#c62828', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                                                                {uploadedFileName || 'File rejected'}
                                                            </div>
                                                            <div style={{ fontSize: '12px', color: '#e53e3e', marginTop: '2px' }}>{uploadErrorMessage}</div>
                                                        </div>
                                                        <button type="button" onClick={this.handleFileRemove} style={{ display: 'inline-flex', alignItems: 'center', gap: '4px', background: '#ffebee', border: '1px solid #ef9a9a', borderRadius: '6px', cursor: 'pointer', color: '#c62828', fontSize: '12px', fontWeight: 600, padding: '6px 14px', flexShrink: 0 }}>
                                                            ✕ Remove
                                                        </button>
                                                    </div>
                                                ) : (
                                                    <style>{`.csv-upload-zone .so-upload-delete,.csv-upload-zone .so-upload-view-value{display:none!important}`}</style>
                                                )}

                                                {/* Upload zone — hidden only when file loaded successfully; stays visible on error so user can re-select */}
                                                <div className="csv-upload-zone" style={{ display: uploadedFileData && uploadedFileData.length > 0 && !uploadErrorMessage ? 'none' : 'block' }}>
                                                <Upload
                                                    key={`upload-${formResetKey}-${uploadKey}`}
                                                    action={UPLOAD_URL}
                                                    accept=".csv,.xls,.xlsx"
                                                    name="file"
                                                    params={{
                                                        brand: this.state.brands,
                                                        board: this.state.boards,
                                                        selected_brand: this.state.brand,
                                                        selected_board: this.state.mboard,
                                                        selected_features: this.state.features,
                                                        selected_vendor: this.state.vendor
                                                    }}
                                                    htmlName="file"
                                                    limit={1}
                                                    renderResult={() => null}
                                                    onSuccess={this.handleFileUpload}
                                                    onRemove={this.handleFileRemove}
                                                    validator={{
                                                        ext: (ext) => {
                                                            const normalizedExt = String(ext || '').toLowerCase().replace(/^\./, '').split('.').pop();
                                                            const allowedExtensions = ['csv', 'xls', 'xlsx'];
                                                            if (allowedExtensions.includes(normalizedExt)) return undefined;
                                                            const errMsg = `".${normalizedExt}" files are not supported. Upload a CSV (.csv) or Excel (.xls/.xlsx) file.`;
                                                            this.setState({ uploadErrorMessage: errMsg });
                                                            return new Error(errMsg);
                                                        },
                                                        size: (size) => {
                                                            if (size <= 10 * 1024 * 1024) return undefined;
                                                            const errMsg = `File too large (${(size / 1024 / 1024).toFixed(1)}MB). Max 10MB.`;
                                                            this.setState({ uploadErrorMessage: errMsg });
                                                            return new Error(errMsg);
                                                        },
                                                    }}
                                                >
                                                    <div style={{
                                                        border: '2px dashed #c8d6e5',
                                                        borderRadius: '10px', padding: '36px 20px',
                                                        textAlign: 'center', backgroundColor: '#f7f9fc',
                                                        cursor: 'pointer', transition: 'all 0.2s',
                                                    }}>
                                                        <CloudUpload style={{ fontSize: '36px', color: '#4a90d9', marginBottom: '8px' }} />
                                                        <div style={{ fontWeight: 600, fontSize: '14px', color: '#333', marginBottom: '6px' }}>
                                                            Click to upload Excel / CSV file
                                                        </div>
                                                        <span
                                                            onClick={(e) => { e.stopPropagation(); this.downloadTemplateCSV(); }}
                                                            style={{ color: '#1976d2', cursor: 'pointer', textDecoration: 'underline', fontSize: '12px' }}
                                                        >
                                                            Download CSV template here
                                                        </span>
                                                    </div>
                                                </Upload>
                                                </div>

                                                {touched.file && formErrors.file && (
                                                    <Typography color="error" variant="caption" style={{ display: 'block', marginTop: '6px' }}>
                                                        {formErrors.file}
                                                    </Typography>
                                                )}

                                                {uploadErrorMessage && validationErrors && validationErrors.length > 0 && (
                                                    <button
                                                        onClick={() => this.setState({ showValidationDialog: true })}
                                                        style={{
                                                            background: '#c62828', color: '#fff',
                                                            border: 'none', borderRadius: '6px', cursor: 'pointer',
                                                            fontSize: '12px', fontWeight: 600, padding: '6px 14px',
                                                            alignSelf: 'flex-start',
                                                        }}
                                                    >
                                                        View Error Details
                                                    </button>
                                                )}

                                                <input
                                                    type="file"
                                                    accept=".csv,.xls,.xlsx"
                                                    style={{ display: 'none' }}
                                                    ref={el => { this._csvFileBtn = el; }}
                                                    onChange={e => {
                                                        const file = e.target.files[0];
                                                        if (!file) return;
                                                        const formData = new FormData();
                                                        formData.append('file', file);
                                                        const token = this.props.cookies.cookies.token;
                                                        fetch(UPLOAD_URL, {
                                                            method: 'POST',
                                                            headers: token ? { Authorization: `Bearer ${token}` } : {},
                                                            body: formData,
                                                        })
                                                            .then(r => r.json())
                                                            .then(res => { this.handleFileUpload(res, file, null, () => this.processUpload()); })
                                                            .catch(() => { this.setState({ uploadErrorMessage: 'Upload failed. Please try again.' }); });
                                                        e.target.value = '';
                                                    }}
                                                />
                                                <button
                                                    type="button"
                                                    onClick={this.processUpload}
                                                    disabled={
                                                        ((!uploadedFileData || uploadedFileData.length === 0) && (!fileErrors || fileErrors.length === 0) && !uploadErrorMessage)
                                                        || allDuplicates
                                                    }
                                                    style={{
                                                        width: '100%',
                                                        display: 'inline-flex', alignItems: 'center', justifyContent: 'center', gap: '6px',
                                                        padding: '11px 24px', borderRadius: '8px', border: 'none',
                                                        backgroundColor: (
                                                            (uploadedFileData && uploadedFileData.length > 0 && !(allDuplicates))
                                                            || (fileErrors && fileErrors.length > 0) || uploadErrorMessage
                                                        ) ? '#2e7d32' : '#e0e0e0',
                                                        color: (
                                                            (uploadedFileData && uploadedFileData.length > 0 && !(allDuplicates))
                                                            || (fileErrors && fileErrors.length > 0) || uploadErrorMessage
                                                        ) ? '#fff' : '#aaa',
                                                        fontWeight: 600, fontSize: '14px',
                                                        cursor: (
                                                            ((!uploadedFileData || uploadedFileData.length === 0) && (!fileErrors || fileErrors.length === 0) && !uploadErrorMessage)
                                                            || (allDuplicates)
                                                        ) ? 'not-allowed' : 'pointer',
                                                        transition: 'all 0.2s',
                                                    }}
                                                >
                                                    <CloudUpload fontSize="small" /> Upload EMACS
                                                </button>

                                                {uploadedFileData && uploadedFileData.length > 0 && !uploadErrorMessage && (
                                                    <div style={{ border: '1px solid #a5d6a7', borderRadius: '8px', overflow: 'hidden' }}>
                                                        <div style={{ display: 'flex', alignItems: 'center', padding: '8px 12px', backgroundColor: '#f1f8e9', borderBottom: '1px solid #c8e6c9' }}>
                                                            <span style={{ fontWeight: 600, fontSize: '12px', color: '#2e7d32' }}>Preview — first 50 rows</span>
                                                        </div>
                                                        <div style={{ overflowX: 'auto', maxHeight: '180px', overflowY: 'auto' }}>
                                                            <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '12px' }}>
                                                                <thead>
                                                                    <tr style={{ backgroundColor: '#f1f8e9', position: 'sticky', top: 0 }}>
                                                                        <th style={{ padding: '6px 10px', textAlign: 'left', borderBottom: '1px solid #c8e6c9', color: '#2e7d32', fontWeight: 600 }}>#</th>
                                                                        <th style={{ padding: '6px 10px', textAlign: 'left', borderBottom: '1px solid #c8e6c9', color: '#2e7d32', fontWeight: 600 }}>EMAC</th>
                                                                        <th style={{ padding: '6px 10px', textAlign: 'left', borderBottom: '1px solid #c8e6c9', color: '#2e7d32', fontWeight: 600 }}>SERIAL NO</th>
                                                                        <th style={{ padding: '6px 10px', textAlign: 'left', borderBottom: '1px solid #c8e6c9', color: '#2e7d32', fontWeight: 600 }}>DESCRIPTION</th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    {uploadedFileData.slice(0, 50).map((row, idx) => (
                                                                        <tr key={idx} style={{ backgroundColor: idx % 2 === 0 ? '#fff' : '#f9fbe7' }}>
                                                                            <td style={{ padding: '5px 10px', borderBottom: '1px solid #e8f5e9', color: '#888' }}>{idx + 1}</td>
                                                                            <td style={{ padding: '5px 10px', borderBottom: '1px solid #e8f5e9', fontFamily: 'monospace' }}>{row.emac || '—'}</td>
                                                                            <td style={{ padding: '5px 10px', borderBottom: '1px solid #e8f5e9' }}>{row.serialno || '—'}</td>
                                                                            <td style={{ padding: '5px 10px', borderBottom: '1px solid #e8f5e9', color: row.description ? '#333' : '#bbb', fontStyle: row.description ? 'normal' : 'italic' }}>{row.description || '(none)'}</td>
                                                                        </tr>
                                                                    ))}
                                                                </tbody>
                                                            </table>
                                                            {uploadedFileData.length > 50 && (
                                                                <div style={{ padding: '5px 10px', color: '#558b2f', fontSize: '11px', textAlign: 'center', background: '#f9fbe7' }}>
                                                                    Showing first 50 of {uploadedFileData.length} entries
                                                                </div>
                                                            )}
                                                        </div>
                                                    </div>
                                                )}
                                            </div>

                                            {/* OR Divider */}
                                            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', width: '48px', flexShrink: 0 }}>
                                                <div style={{ flex: 1, width: '1px', backgroundColor: '#e8e8e8' }} />
                                                <span style={{ padding: '10px 0', fontSize: '12px', fontWeight: 700, color: '#bbb', letterSpacing: '1px' }}>OR</span>
                                                <div style={{ flex: 1, width: '1px', backgroundColor: '#e8e8e8' }} />
                                            </div>

                                            {/* Right: MAC Range */}
                                            <div
                                                onClick={() => this.setState({ activePanel: 'macrange' })}
                                                style={{
                                                    flex: 1, padding: '24px', display: 'flex', flexDirection: 'column', gap: '16px',
                                                    transition: 'filter 0.2s',
                                                }}
                                            >
                                                <p style={{ margin: 0, fontSize: '13px', color: '#888', fontWeight: 500 }}>Need to generate MACs?</p>

                                                <div>
                                                    <label style={{ display: 'block', fontSize: '13px', fontWeight: 600, color: '#444', marginBottom: '6px' }}>
                                                        Start MAC <span style={{ color: '#e53e3e' }}>*</span>
                                                    </label>
                                                    <Input
                                                        key={`startmac-${formResetKey}`}
                                                        name="start_mac"
                                                        value={start_mac}
                                                        onChange={value => this.handleMacChange('start_mac', value)}
                                                        placeholder="8C:7A:B3:DE:C9:6D or 8C7AB3DEC96D"
                                                        style={{ width: '100%', fontFamily: 'monospace' }}
                                                    />
                                                    {touched.start_mac && formErrors.start_mac && <Typography color="error" variant="caption">{formErrors.start_mac}</Typography>}
                                                </div>

                                                <div>
                                                    <label style={{ display: 'block', fontSize: '13px', fontWeight: 600, color: '#444', marginBottom: '6px' }}>
                                                        End MAC <span style={{ color: '#e53e3e' }}>*</span>
                                                    </label>
                                                    <Input
                                                        key={`endmac-${formResetKey}`}
                                                        name="end_mac"
                                                        value={end_mac}
                                                        onChange={value => this.handleMacChange('end_mac', value)}
                                                        placeholder="8C:7A:B3:DE:C9:6D or 8C7AB3DEC96D"
                                                        style={{ width: '100%', fontFamily: 'monospace' }}
                                                    />
                                                    {touched.end_mac && formErrors.end_mac && <Typography color="error" variant="caption">{formErrors.end_mac}</Typography>}
                                                </div>

                                                {(touched.start_mac || touched.end_mac) && formErrors.range && <Typography color="error" variant="caption">{formErrors.range}</Typography>}

                                                {/* Generate EMAC button */}
                                                {uploadMode === 'macrange' && start_mac && end_mac && !formErrors.range && !formErrors.start_mac && !formErrors.end_mac && (
                                                    <button
                                                        type="button"
                                                        onClick={this.generateMacPreview}
                                                        disabled={isGeneratingMacPreview}
                                                        style={{
                                                            display: 'inline-flex', alignItems: 'center', gap: '6px',
                                                            padding: '8px 18px', borderRadius: '8px', border: 'none',
                                                            backgroundColor: isGeneratingMacPreview ? '#e0e0e0' : '#1565c0',
                                                            color: isGeneratingMacPreview ? '#aaa' : '#fff',
                                                            fontWeight: 600, fontSize: '13px',
                                                            cursor: isGeneratingMacPreview ? 'not-allowed' : 'pointer',
                                                            alignSelf: 'flex-start',
                                                        }}
                                                    >
                                                        {isGeneratingMacPreview
                                                            ? <><CircularProgress size={13} style={{ color: '#aaa' }} /> Generating...</>
                                                            : <><Storage fontSize="small" /> Generate EMAC</>}
                                                    </button>
                                                )}

                                                {/* Generated count + Download Preview Range + Upload Sheet */}
                                                {macPreviewData && macPreviewData.length > 0 && (
                                                    <div style={{ border: '1px solid #a5d6a7', borderRadius: '8px', overflow: 'hidden' }}>
                                                        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '10px 14px', backgroundColor: '#e8f5e9' }}>
                                                            <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                                                <CheckCircleOutline style={{ color: '#2e7d32', fontSize: '18px' }} />
                                                                <span style={{ fontWeight: 700, fontSize: '14px', color: '#1b5e20' }}>
                                                                    {macPreviewData.length.toLocaleString()} EMACs generated
                                                                </span>
                                                            </div>
                                                            <button
                                                                type="button"
                                                                onClick={this.downloadMacPreviewCSV}
                                                                style={{
                                                                    display: 'inline-flex', alignItems: 'center', gap: '5px',
                                                                    padding: '6px 14px', borderRadius: '6px', border: 'none',
                                                                    backgroundColor: '#2e7d32', color: '#fff',
                                                                    fontWeight: 600, fontSize: '12px', cursor: 'pointer',
                                                                }}
                                                            >
                                                                <GetApp style={{ fontSize: '15px' }} /> Download Preview Range
                                                            </button>
                                                        </div>
                                                        <div style={{ padding: '10px 14px', backgroundColor: '#f1f8e9', borderTop: '1px solid #c8e6c9', display: 'flex', alignItems: 'center', gap: '10px' }}>
                                                            <span style={{ fontSize: '12px', color: '#558b2f' }}>Fill in serial numbers, then upload the sheet:</span>
                                                            <Upload
                                                                key={`mac-sheet-upload-${formResetKey}`}
                                                                action={UPLOAD_URL}
                                                                accept=".csv,.xls,.xlsx"
                                                                name="file"
                                                                htmlName="file"
                                                                limit={1}
                                                                renderResult={() => null}
                                                                onSuccess={(res, file) => {
                                                                    this.handleFileUpload(res, file);
                                                                    this.setState({ uploadMode: 'csv' });
                                                                }}
                                                                validator={{
                                                                    ext: ext => {
                                                                        const normalizedExt = String(ext || '').toLowerCase().replace(/^\./, '').split('.').pop();
                                                                        return ['csv', 'xls', 'xlsx'].includes(normalizedExt) ? undefined : new Error(`".${normalizedExt}" not supported. Use CSV or Excel.`);
                                                                    },
                                                                    size: size => size <= 10 * 1024 * 1024 ? undefined : new Error('File too large. Max 10MB.'),
                                                                }}
                                                            >
                                                                
                                                            </Upload>
                                                        </div>
                                                    </div>
                                                )}
                                            </div>

                                        </div>

                                        {/* Action Buttons */}
                                        <div style={{ display: 'flex', gap: '12px', justifyContent: 'flex-end', flexWrap: 'wrap' }}>
                                            <button
                                                type="button"
                                                onClick={this.handlePreviewUpload}
                                                disabled={!isFormValid || isAnalyzingPreview || isUploading}
                                                style={{
                                                    display: 'inline-flex', alignItems: 'center', gap: '6px',
                                                    padding: '10px 24px', borderRadius: '8px',
                                                    border: `2px solid ${(!isFormValid || isAnalyzingPreview || isUploading) ? '#ccc' : '#1976d2'}`,
                                                    backgroundColor: 'transparent',
                                                    color: (!isFormValid || isAnalyzingPreview || isUploading) ? '#aaa' : '#1976d2',
                                                    fontWeight: 600, fontSize: '14px',
                                                    cursor: (!isFormValid || isAnalyzingPreview || isUploading) ? 'not-allowed' : 'pointer',
                                                    transition: 'all 0.2s',
                                                }}
                                            >
                                                {isAnalyzingPreview
                                                    ? <><CircularProgress size={14} style={{ color: '#1976d2' }} /> Analyzing...</>
                                                    : <><Visibility fontSize="small" /> Preview</>}
                                            </button>


                                            <button
                                                type="button"
                                                onClick={this.processUpload}
                                                disabled={
                                                    !isFormValid || isUploading
                                                    || (uploadMode === 'csv' && !uploadedFileData)
                                                    || allDuplicates
                                                    || (previewData && (previewData.unique_count === 0 || previewData.database_check?.will_be_uploaded === 0))
                                                }
                                                style={{
                                                    display: 'inline-flex', alignItems: 'center', gap: '6px',
                                                    padding: '10px 24px', borderRadius: '8px', border: 'none',
                                                    backgroundColor: (
                                                        isFormValid && !isUploading
                                                        && (uploadMode === 'macrange' || uploadedFileData)
                                                        && !(allDuplicates)
                                                        && !(previewData && (previewData.unique_count === 0 || previewData.database_check?.will_be_uploaded === 0))
                                                    ) ? '#2e7d32' : '#e0e0e0',
                                                    color: (
                                                        isFormValid && !isUploading
                                                        && (uploadMode === 'macrange' || uploadedFileData)
                                                        && !(allDuplicates)
                                                        && !(previewData && (previewData.unique_count === 0 || previewData.database_check?.will_be_uploaded === 0))
                                                    ) ? '#fff' : '#aaa',
                                                    fontWeight: 600, fontSize: '14px',
                                                    cursor: (
                                                        !isFormValid || isUploading
                                                        || (uploadMode === 'csv' && !uploadedFileData)
                                                        || (allDuplicates)
                                                        || (previewData && (previewData.unique_count === 0 || previewData.database_check?.will_be_uploaded === 0))
                                                    ) ? 'not-allowed' : 'pointer',
                                                    transition: 'all 0.2s',
                                                }}
                                            >
                                                {isUploading
                                                    ? <><CircularProgress size={14} style={{ color: '#fff' }} /> Uploading...</>
                                                    : <><CloudUpload fontSize="small" /> Upload Directly</>}
                                            </button>
                                        </div>
                                    </React.Fragment>
                                )}
                            </Form>
                        </Card.Body>
                    ) : (
                        <Card.Body>
                            <Alert type="error" style={{ margin: '20px' }}>
                                You don't have permission to access this feature.
                            </Alert>
                        </Card.Body>
                    )}
                </Card>

                <Dialog
                    open={showPreviewDialog}
                    onClose={() => this.setState({ showPreviewDialog: false })}
                    maxWidth="md"
                    fullWidth
                    scroll="paper"
                    style={{ zIndex: 1400 }}
                >
                    <DialogTitle>
                        <Typography variant="h6" style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                            <InfoOutlined color="primary" />
                            Upload Preview
                        </Typography>
                        <Typography variant="subtitle2" color="textSecondary">
                            Review what will be uploaded before proceeding
                        </Typography>
                    </DialogTitle>

                    <DialogContent dividers>
                        {previewSummary && (
                            <div>
                                <div className={classes.previewSection}>
                                    <Typography variant="h6" style={{ marginBottom: '16px', color: '#1976d2' }}>
                                        {previewSummary.title}
                                    </Typography>

                                    <div className={classes.statsGrid}>
                                        {previewSummary.items.map((item, index) => (
                                            <div key={index} className={classes.statItem}>
                                                <Typography variant="body2" color="textSecondary">
                                                    {item.label}
                                                </Typography>
                                                <Typography
                                                    variant="h6"
                                                    style={{
                                                        color: item.color,
                                                        fontWeight: 600,
                                                        marginTop: '4px'
                                                    }}
                                                >
                                                    {item.value}
                                                </Typography>
                                            </div>
                                        ))}
                                    </div>

                                    <Alert
                                        severity={previewData?.summary?.upload_possible === false ? "warning" : "info"}
                                        style={{ marginTop: '16px' }}
                                    >
                                        <Typography variant="body1">
                                            {previewSummary.message}
                                        </Typography>
                                    </Alert>
                                </div>

                                {/* {previewData?.sample_data && previewData.sample_data.length > 0 && (
                                    <div className={classes.previewSection}>
                                        <Typography variant="h6" style={{ marginBottom: '12px' }}>
                                            Sample MAC Addresses
                                        </Typography>
                                        <TableContainer component={Paper} className={classes.previewTable}>
                                            <Table size="small">
                                                <TableHead>
                                                    <TableRow>
                                                        <TableCell><strong>MAC Address</strong></TableCell>
                                                        <TableCell><strong>Status</strong></TableCell>
                                                    </TableRow>
                                                </TableHead>
                                                <TableBody>
                                                    {previewData.sample_data.map((item, index) => (
                                                        <TableRow key={index}>
                                                            <TableCell>{item.emac}</TableCell>
                                                            <TableCell>
                                                                <span className={`${classes.statusBadge} ${item.status.includes('upload') ? classes.statusWillUpload :
                                                                    item.status.includes('Duplicate') ? classes.statusDuplicate :
                                                                        item.status.includes('exists') ? classes.statusExists :
                                                                            classes.statusInvalid
                                                                    }`}>
                                                                    {item.status}
                                                                </span>
                                                            </TableCell>
                                                        </TableRow>
                                                    ))}
                                                </TableBody>
                                            </Table>
                                        </TableContainer>
                                        <Typography variant="caption" color="textSecondary" style={{ display: 'block', marginTop: '8px' }}>
                                            Showing {previewData.sample_data.length} sample entries
                                        </Typography>
                                    </div>
                                )} */}

                                {previewData?.invalid_samples && previewData.invalid_samples.length > 0 && (
                                    <div className={classes.previewSection}>
                                        <Alert severity="warning" style={{ marginBottom: '12px' }}>
                                            <Typography variant="body2">
                                                Found {previewData.file_statistics?.invalid_entries || previewData.invalid_samples.length} invalid entries
                                            </Typography>
                                        </Alert>
                                    </div>
                                )}
                            </div>
                        )}
                    </DialogContent>

                    <DialogActions style={{ padding: '16px 24px', borderTop: '1px solid #e0e0e0' }}>
                        <button
                            onClick={() => this.setState({ showPreviewDialog: false })}
                            className={classes.modernButton}
                            style={{ backgroundColor: '#6c757d' }}
                        >
                            Cancel
                        </button>

                        {this.state.previewDuplicateMacs && this.state.previewDuplicateMacs.length > 0 && (
                            <button
                                onClick={this.downloadPreviewDuplicatesCSV}
                                className={classes.modernButton}
                                style={{ backgroundColor: '#f57c00' }}
                            >
                                <GetApp fontSize="small" style={{ marginRight: '6px' }} />
                                Download Duplicates ({this.state.previewDuplicateMacs.length})
                            </button>
                        )}

                        {(() => {
                            const canUpload = previewData?.summary?.upload_possible !== false
                                && previewData?.can_upload !== false
                                && (previewData?.unique_count ?? previewData?.database_check?.will_be_uploaded ?? 1) > 0;
                            return (
                                <button
                                    onClick={canUpload ? this.confirmUpload : undefined}
                                    className={classes.modernButton}
                                    disabled={!canUpload}
                                    style={{ backgroundColor: canUpload ? '#2e7d32' : '#b0bec5', cursor: canUpload ? 'pointer' : 'not-allowed' }}
                                >
                                    <CloudUpload fontSize="small" />
                                    Confirm & Upload
                                </button>
                            );
                        })()}
 
                    </DialogActions>
                </Dialog>

                <Dialog
                    open={showResultDialog}
                    onClose={() => {
                        this.setState({ showResultDialog: false });
                        if (uploadStatus === 'success') {
                            setTimeout(() => {
                                this.resetForm();
                            }, 300);
                        }
                    }}
                    maxWidth="sm"
                    fullWidth
                    style={{ zIndex: 1400 }}
                >
                    <DialogTitle>
                        <Typography variant="h6" style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                            {uploadStatus === 'success' ? (
                                <CheckCircleOutline style={{ color: '#2e7d32' }} />
                            ) : (
                                <ErrorOutline style={{ color: '#d32f2f' }} />
                            )}
                            {uploadStatus === 'success' ? 'Upload Successful' : 'Upload Failed'}
                        </Typography>
                    </DialogTitle>
                    <DialogContent>
                        {uploadStatus === 'success' && uploadResult && (
                            <>
                                <Alert type="success" style={{ marginBottom: '16px' }}>
                                    {uploadMode === 'macrange'
                                        ? `Successfully generated ${uploadResult.generated_count || previewCount} MAC addresses!`
                                        : 'MAC addresses uploaded successfully!'}
                                </Alert>

                                <div className={classes.statsContainer}>
                                    <div className={classes.statCard}>
                                        <div className={`${classes.statValue} ${classes.statPositive}`}>
                                            {uploadResult.inserted_count || 'N/A'}
                                        </div>
                                        <div className={classes.statLabel}>Inserted</div>
                                    </div>
                                    <div className={classes.statCard}>
                                        <div className={`${classes.statValue}`} style={{ color: '#f57c00' }}>
                                            {uploadResult.skipped_count || '0'}
                                        </div>
                                        <div className={classes.statLabel}>Skipped</div>
                                    </div>
                                </div>
                            </>
                        )}

                        {uploadStatus === 'error' && (
                            <Alert type="error">
                                <Typography variant="body1" style={{ fontWeight: 600 }}>
                                    Upload Failed
                                </Typography>
                                <Typography variant="body2" style={{ marginTop: '8px' }}>
                                    {uploadResult?.message || 'An unknown error occurred'}
                                </Typography>
                            </Alert>
                        )}
                    </DialogContent>
                    <DialogActions>
                        <button
                            onClick={() => {
                                this.setState({ showResultDialog: false });
                                if (uploadStatus === 'success') {
                                    setTimeout(() => {
                                        this.resetForm();
                                    }, 300);
                                }
                            }}
                            className={classes.modernButton}
                            style={{ backgroundColor: '#1976d2' }}
                        >
                            {uploadStatus === 'success' ? 'Start New Upload' : 'Close'}
                        </button>
                    </DialogActions>
                </Dialog>
            </React.Fragment>
        );
    }
}

export default withStyles(styles)(withCookies(BundleUploader));
